var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-in-no-time",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-in-no-time:not(.animated) .animable {opacity: 0;}svg#freepik_stories-in-no-time.animated #freepik--speech-bubble--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-in-no-time.animated #freepik--character-2--inject-2 {animation: 1.9s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-in-no-time.animated #freepik--Plants--inject-2 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-in-no-time.animated #freepik--character-1--inject-2 {animation: 1s 1 forwards ease-out lightSpeedRight;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "249.975px 342.733px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.32,247.81c-90.8-52.43-237.54-52.43-327.76,0S-4.17,385.24,86.63,437.66s237.55,52.43,327.76,0S504.13,300.24,413.32,247.81Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "249.975px 342.733px"
    },
    id: "el5apb4ry2wbv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "262.339px 369.986px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.11,340c6.7-3.86,17.52-3.86,24.18,0s6.62,10.13-.08,14-17.52,3.87-24.18,0S439.41,343.89,446.11,340Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "458.16px 347.004px"
    },
    id: "elg0cmypgczhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,345.65l-12.39-16.84a14.68,14.68,0,0,0-10.69-5.94l-18.26-1.4-29-17.63,10.85-6.27a1,1,0,0,0,0-1.69l-4.51-2.57a5.88,5.88,0,0,0-5.84,0L79.43,354.8a1,1,0,0,0,0,1.69l4.4,2.54a5.86,5.86,0,0,0,5.87,0l46.16-26.66,28.61,16.41,3.74,10.53a16.63,16.63,0,0,0,15.66,11.05h26.7l18.12,10.46,43.78-25.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "175.717px 336.677px"
    },
    id: "el4ldwn2wpgdl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.52,330.11c-28.94-16.7-75.71-16.7-104.46,0-25.41,14.76-28.23,37.62-8.58,54.28-15.86-1-32.28,2-44.39,9.07-21.25,12.35-21.14,32.37.25,44.72s56,12.34,77.2,0c16.9-9.83,20.27-24.51,10.18-36.32,24.36,3.53,51.17-.22,70.15-11.24C447.62,373.92,447.47,346.83,418.52,330.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "342.779px 382.512px"
    },
    id: "elo4qmggnik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.58,376.23c-7.62-4.4-19.94-4.4-27.51,0s-7.53,11.54.09,15.94,19.94,4.4,27.51,0S90.21,380.63,82.58,376.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "68.8719px 384.2px"
    },
    id: "el2t2pgp5cxl9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-2",
    className: "animable",
    style: {
      transformOrigin: "111.21px 116.51px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "156.77 31.94 162.12 28.88 162.45 145.82 162.44 145.83 119.32 170.45 119.3 164.33 118.98 53.51 156.77 31.94",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "140.715px 99.665px"
    },
    id: "elyhj4fwlg7oh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1rhr6xwlos5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "157.09 142.75 156.77 31.94 162.12 28.88 162.45 145.82 162.44 145.83 157.07 142.76 157.09 142.75",
    style: {
      opacity: 0.1,
      transformOrigin: "159.61px 87.355px"
    },
    className: "animable",
    id: "el31soxk45ni8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8krj3196p35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119.3 164.33 157.07 142.76 162.44 145.83 119.32 170.45 119.3 164.33",
    style: {
      opacity: 0.2,
      transformOrigin: "140.87px 156.605px"
    },
    className: "animable",
    id: "elbi2fz5h292u"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "97.76 65.63 103.11 62.57 103.44 179.51 103.43 179.52 60.31 204.14 60.29 198.02 59.97 87.2 97.76 65.63",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "81.705px 133.355px"
    },
    id: "ell74blriyxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm6gnz9ocvc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "98.08 176.44 97.76 65.63 103.11 62.57 103.44 179.51 103.43 179.52 98.06 176.45 98.08 176.44",
    style: {
      opacity: 0.1,
      transformOrigin: "100.6px 121.045px"
    },
    className: "animable",
    id: "elltg93a72yk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgivx9f7y04"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60.29 198.02 98.06 176.45 103.43 179.52 60.31 204.14 60.29 198.02",
    style: {
      opacity: 0.2,
      transformOrigin: "81.86px 190.295px"
    },
    className: "animable",
    id: "elojgauh3fwvo"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-2",
    className: "animable",
    style: {
      transformOrigin: "292.385px 78.6887px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.85,57h0a3.92,3.92,0,0,1-.32-.25h0Z",
    style: {
      fill: "none",
      transformOrigin: "293.69px 56.875px"
    },
    id: "eluqf2x8yh6qd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.64,58.5l-.06,0,.06,0Z",
    style: {
      fill: "none",
      transformOrigin: "295.61px 58.5px"
    },
    id: "elt9b25c6av9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,51.52c-.15,0-.3-.06-.45-.09l.43.08Z",
    style: {
      fill: "none",
      transformOrigin: "282.775px 51.475px"
    },
    id: "el51wpj76bbyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.05,51.77l-.41-.1.39.1Z",
    style: {
      fill: "none",
      transformOrigin: "283.845px 51.72px"
    },
    id: "el84ulfaqikot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.36,53.47l0,0,0,0Z",
    style: {
      fill: "none",
      transformOrigin: "288.36px 53.47px"
    },
    id: "eler1hxf3adq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.38,106.62q.44-.14.84-.3Q302.81,106.49,302.38,106.62Z",
    style: {
      fill: "none",
      transformOrigin: "302.8px 106.47px"
    },
    id: "elyvfdmghifs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,70.94h0l-.18-.31h0Z",
    style: {
      fill: "none",
      transformOrigin: "305.58px 70.785px"
    },
    id: "elvj34acwpky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.57,69.13l-.22-.35h0Z",
    style: {
      fill: "none",
      transformOrigin: "304.46px 68.955px"
    },
    id: "elxr17twcxgyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.44,60.18l-.2-.18.2.18Z",
    style: {
      fill: "none",
      transformOrigin: "297.34px 60.09px"
    },
    id: "elnsm32wppn88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.64 61.42 298.63 61.41 298.64 61.42 298.64 61.42",
    style: {
      fill: "none",
      transformOrigin: "298.635px 61.415px"
    },
    id: "elcpgao9t6bir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.63,64.94l0,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "301.63px 64.94px"
    },
    id: "elpetgo76dr1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,107.06c.32,0,.62-.06.93-.11C300.61,107,300.31,107,300,107.06Z",
    style: {
      fill: "none",
      transformOrigin: "300.465px 107.005px"
    },
    id: "el1bmtt4ghfcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,99c.47.45.94.9,1.43,1.32C283.75,99.86,283.28,99.41,282.81,99Z",
    style: {
      fill: "none",
      transformOrigin: "283.525px 99.66px"
    },
    id: "elrx2tnbupe3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,104.23c.45.26.89.49,1.33.71C290.54,104.72,290.1,104.49,289.65,104.23Z",
    style: {
      fill: "none",
      transformOrigin: "290.315px 104.585px"
    },
    id: "eldabga99ycwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,103.2c.54.36,1.09.71,1.64,1C289.1,103.91,288.55,103.56,288,103.2Z",
    style: {
      fill: "none",
      transformOrigin: "288.82px 103.7px"
    },
    id: "elr2tklcxzkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,106.84l.48.09Z",
    style: {
      fill: "none",
      transformOrigin: "296.62px 106.885px"
    },
    id: "elh5q9xk3g1ca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,74.53l-.06-.13h0Z",
    style: {
      fill: "none",
      transformOrigin: "307.55px 74.465px"
    },
    id: "el72ytedvmmeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,51.3h0Z",
    style: {
      fill: "none",
      transformOrigin: "277.62px 51.3px"
    },
    id: "elakvrckaruut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.78,51.19l-.29,0,.23,0Z",
    style: {
      fill: "none",
      transformOrigin: "280.635px 51.19px"
    },
    id: "ela0nb0mcsyu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,51.17h0l-.26,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "278.73px 51.17px"
    },
    id: "el5e6av43gd1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,51.32h0l-.47-.06.42,0Z",
    style: {
      fill: "none",
      transformOrigin: "281.765px 51.29px"
    },
    id: "elw5rk8ri8pdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.17,51.62h0l-.17,0,.09,0Z",
    style: {
      fill: "none",
      transformOrigin: "276.085px 51.62px"
    },
    id: "el0ll2pgkg0u09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.12,52l-.16.06.14-.06Z",
    style: {
      fill: "none",
      transformOrigin: "275.04px 52.03px"
    },
    id: "el87ype1484w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.87,55.56l-.06-.05.06.05Z",
    style: {
      fill: "none",
      transformOrigin: "291.84px 55.535px"
    },
    id: "el8ib85aah9c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,97.57c0,.21-.07.43-.11.64C311.89,98,311.92,97.78,312,97.57Z",
    style: {
      fill: "none",
      transformOrigin: "311.945px 97.89px"
    },
    id: "el05scv6jw83d3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,99.81c-.05.19-.1.38-.16.57C311.35,100.19,311.4,100,311.45,99.81Z",
    style: {
      fill: "none",
      transformOrigin: "311.37px 100.095px"
    },
    id: "eldzjl49wbs1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.73,98.73c0,.2-.09.4-.14.59C311.64,99.13,311.69,98.93,311.73,98.73Z",
    style: {
      fill: "none",
      transformOrigin: "311.66px 99.025px"
    },
    id: "el8yx7hxgrqcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.74,101.82l-.21.5Z",
    style: {
      fill: "none",
      transformOrigin: "310.635px 102.07px"
    },
    id: "el7qbhicu2d8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12,100.84c-.06.18-.12.36-.19.54C311,101.2,311.06,101,311.12,100.84Z",
    style: {
      fill: "none",
      transformOrigin: "311.025px 101.11px"
    },
    id: "elzk9izooc8i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.31,102.74c-.08.16-.15.32-.24.47C310.16,103.06,310.23,102.9,310.31,102.74Z",
    style: {
      fill: "none",
      transformOrigin: "310.19px 102.975px"
    },
    id: "elcuyx907awt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.18 80.91 310.18 80.9 310.18 80.91 310.18 80.91",
    style: {
      fill: "none",
      transformOrigin: "310.18px 80.905px"
    },
    id: "eldx9tvmpfjip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.79,54.24c.32.18.63.37.94.57C290.42,54.61,290.11,54.42,289.79,54.24Z",
    style: {
      fill: "none",
      transformOrigin: "290.26px 54.525px"
    },
    id: "eljb7zypvthc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.26,95l-.06.85Z",
    style: {
      fill: "none",
      transformOrigin: "312.23px 95.425px"
    },
    id: "el6cqtiohptt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.14,96.31l-.09.74Z",
    style: {
      fill: "none",
      transformOrigin: "312.095px 96.68px"
    },
    id: "el9ogr4xw6mvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.32,93.26q0,.67,0,1.32Q312.32,93.94,312.32,93.26Z",
    style: {
      fill: "none",
      transformOrigin: "312.32px 93.92px"
    },
    id: "elfmkaiqt0a6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.26,91.3v-.13a.62.62,0,0,0,0,.13Z",
    style: {
      fill: "none",
      transformOrigin: "312.258px 91.235px"
    },
    id: "el1o1y0a0qs9x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,89l0-.25,0,.25Z",
    style: {
      fill: "none",
      transformOrigin: "312px 88.875px"
    },
    id: "el6l3vuffb2la",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.81,106.18l.33-.34Z",
    style: {
      fill: "none",
      transformOrigin: "307.975px 106.01px"
    },
    id: "elzpyjht1oecp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.55,86l0-.14,0,.14Z",
    style: {
      fill: "none",
      transformOrigin: "311.55px 85.93px"
    },
    id: "el1z59yyjn003",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.83,87.49h0c0-.2-.07-.4-.11-.61h0C311.76,87.09,311.79,87.29,311.83,87.49Z",
    style: {
      fill: "none",
      transformOrigin: "311.775px 87.185px"
    },
    id: "eleldjkd0wup7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.83,103.6c-.08.15-.17.3-.26.44C309.66,103.9,309.75,103.75,309.83,103.6Z",
    style: {
      fill: "none",
      transformOrigin: "309.7px 103.82px"
    },
    id: "elypim4ni548l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,107l-.38.28Z",
    style: {
      fill: "none",
      transformOrigin: "306.62px 107.14px"
    },
    id: "ellqfk41opeyl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,105.15a3.79,3.79,0,0,1-.31.37A3.79,3.79,0,0,0,308.75,105.15Z",
    style: {
      fill: "none",
      transformOrigin: "308.595px 105.335px"
    },
    id: "eldstr8ixrbzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.31,104.41c-.09.13-.18.27-.28.4C309.13,104.68,309.22,104.54,309.31,104.41Z",
    style: {
      fill: "none",
      transformOrigin: "309.17px 104.61px"
    },
    id: "elnk9nm18hjt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.49,106.46a3.38,3.38,0,0,1-.35.31A3.38,3.38,0,0,0,307.49,106.46Z",
    style: {
      fill: "none",
      transformOrigin: "307.315px 106.615px"
    },
    id: "el66ljkbruqd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.59,54.93l-.33.22Z",
    style: {
      fill: "none",
      transformOrigin: "274.425px 55.04px"
    },
    id: "elpdd8jezd3v9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45,81.43c-.22-.58-.43-1.16-.62-1.74.19.58.4,1.16.62,1.74Z",
    style: {
      fill: "none",
      transformOrigin: "271.14px 80.56px"
    },
    id: "eljpuh7ux8e9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.78,79.55h0c-.2-.6-.38-1.2-.55-1.8h0C270.4,78.35,270.58,79,270.78,79.55Z",
    style: {
      fill: "none",
      transformOrigin: "270.505px 78.65px"
    },
    id: "elq1ok4ykwq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.46,103.73a9.5,9.5,0,0,1-.95.11l-.2,0c-.4,0-.8,0-1.21,0l-.28,0a11.44,11.44,0,0,1-1.4-.14c-.31,0-.62-.1-.94-.17l-.3-.08-.66-.16c-.37-.1-.75-.22-1.13-.35l-.23-.08-.92-.35-.35-.15-1-.46-.37-.18c-.44-.23-.88-.46-1.33-.72s-1.1-.67-1.65-1l-.27-.18c-.52-.36-1-.73-1.54-1.12l-.3-.23c-.51-.41-1-.82-1.52-1.26l-.13-.12c-.49-.43-1-.88-1.43-1.33-.08-.08-.16-.15-.23-.23-.36-.35-.72-.72-1.07-1.09l-.06-.06-1-1.09-.2-.24c-.53-.61-1-1.23-1.54-1.87l-.16-.21c-.4-.52-.78-1-1.16-1.58l-.17-.23c-.36-.52-.71-1-1.06-1.58l-.24-.38c-.28-.44-.55-.89-.81-1.33-.06-.1-.12-.19-.17-.29-.3-.51-.59-1-.87-1.55l-.2-.39c-.22-.42-.43-.84-.64-1.26-.07-.14-.14-.28-.2-.42-.26-.53-.5-1.06-.74-1.6l-.09-.23c-.21-.49-.41-1-.6-1.46-.06-.14-.11-.29-.17-.44-.22-.57-.43-1.15-.62-1.74,0,0,0-.09-.05-.14-.2-.6-.38-1.2-.55-1.79a3.57,3.57,0,0,0-.1-.35c-.19-.7-.36-1.4-.51-2.09,0-.16-.06-.31-.1-.46l-.15-.82c0-.19-.07-.38-.1-.57s-.09-.56-.13-.84-.05-.33-.07-.5c-.08-.6-.14-1.2-.18-1.79,0-.13,0-.25,0-.38,0-.61-.06-1.22-.06-1.82,0-5,1.34-8.81,3.59-11.34,3.37-.72,7.45.07,11.85,2.61,11.54,6.66,20.88,22.82,20.84,36.09,0,5-1.33,8.8-3.58,11.33l-.3.07Z",
    style: {
      fill: "none",
      transformOrigin: "292.49px 78.5928px"
    },
    id: "el48m342qul3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.94,90.39c-.28-.43-.55-.88-.81-1.33.26.45.53.89.81,1.33Z",
    style: {
      fill: "none",
      transformOrigin: "275.535px 89.725px"
    },
    id: "elpltinw6jyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.27,96.25c-.53-.61-1-1.23-1.54-1.87.5.64,1,1.26,1.54,1.87Z",
    style: {
      fill: "none",
      transformOrigin: "279.5px 95.315px"
    },
    id: "el3hs370fbejy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.25,85.58c.21.42.42.84.64,1.25C273.67,86.42,273.46,86,273.25,85.58Z",
    style: {
      fill: "none",
      transformOrigin: "273.57px 86.205px"
    },
    id: "el2jjh5lpuihy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,88.78h0c-.3-.51-.59-1-.87-1.55h0C274.37,87.75,274.66,88.27,275,88.78Z",
    style: {
      fill: "none",
      transformOrigin: "274.565px 88.005px"
    },
    id: "elc5n26mm266i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.28,105.82l.07,0c-.28.15-.57.29-.86.42h0C303.77,106.08,304,106,304.28,105.82Z",
    style: {
      fill: "none",
      transformOrigin: "303.92px 106.03px"
    },
    id: "el4q0jzuuo6kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.24,92.36c-.36-.52-.71-1-1.05-1.58.34.53.69,1.06,1.05,1.58Z",
    style: {
      fill: "none",
      transformOrigin: "276.715px 91.57px"
    },
    id: "els7byaern6z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,97.57c-.33-.35-.65-.71-1-1.08h0C280.8,96.86,281.12,97.22,281.45,97.57Z",
    style: {
      fill: "none",
      transformOrigin: "280.95px 97.03px"
    },
    id: "ell0ct30tp45q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.89,101.67c-.54-.43-1.08-.87-1.6-1.34a.6.6,0,0,0,.08.08C284.87,100.84,285.38,101.26,285.89,101.67Z",
    style: {
      fill: "none",
      transformOrigin: "285.09px 101px"
    },
    id: "eloz4rgznh0z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,103l.2.13c-.65-.44-1.3-.91-1.93-1.4l.19.15C286.7,102.29,287.21,102.66,287.73,103Z",
    style: {
      fill: "none",
      transformOrigin: "286.965px 102.43px"
    },
    id: "elu3vsqdmeb4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.45,105.74h0Z",
    style: {
      fill: "none",
      transformOrigin: "304.45px 105.74px"
    },
    id: "elk8gm703pv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.58,98.73c-.36-.35-.72-.72-1.07-1.09C281.86,98,282.22,98.38,282.58,98.73Z",
    style: {
      fill: "none",
      transformOrigin: "282.045px 98.185px"
    },
    id: "el8pd7ja26xe5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35,105.58h0c-.41-.18-.81-.36-1.22-.57l.22.11Q291.86,105.37,292.35,105.58Z",
    style: {
      fill: "none",
      transformOrigin: "291.74px 105.295px"
    },
    id: "elktmbdc1rrh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.63,106.09l.23.08c.37.13.74.24,1.11.35a21.37,21.37,0,0,1-2.28-.79h0Z",
    style: {
      fill: "none",
      transformOrigin: "293.83px 106.125px"
    },
    id: "ell0ij2e1bi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.28,107.07l-.66,0,.66,0Z",
    style: {
      fill: "none",
      transformOrigin: "297.95px 107.07px"
    },
    id: "elhalw6hz1v9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.75,107.08c-.39,0-.8,0-1.21,0h0C299,107.1,299.36,107.1,299.75,107.08Z",
    style: {
      fill: "none",
      transformOrigin: "299.145px 107.088px"
    },
    id: "elxf1pqavks7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.23,106.67c-.34.09-.69.17-1,.24h0C301.56,106.84,301.9,106.76,302.23,106.67Z",
    style: {
      fill: "none",
      transformOrigin: "301.73px 106.79px"
    },
    id: "eln8ds04vt5ll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,106.75c-.12,0-.24-.06-.36-.09l.08,0Z",
    style: {
      fill: "none",
      transformOrigin: "295.74px 106.705px"
    },
    id: "elwahrzh9bs5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.57,94.16h0c-.4-.52-.78-1-1.16-1.58h0C277.79,93.13,278.17,93.65,278.57,94.16Z",
    style: {
      fill: "none",
      transformOrigin: "277.99px 93.37px"
    },
    id: "elnymbwekdc09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,57.83l-.24.34Z",
    style: {
      fill: "none",
      transformOrigin: "271.47px 58px"
    },
    id: "elp2bor2kkdcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.12,57.14c-.09.11-.18.21-.26.32C271.94,57.35,272,57.25,272.12,57.14Z",
    style: {
      fill: "none",
      transformOrigin: "271.99px 57.3px"
    },
    id: "elbyyp0g5n7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.11,58.58l-.22.36Z",
    style: {
      fill: "none",
      transformOrigin: "271px 58.76px"
    },
    id: "el8ngi8l5dj0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.28,55.92l-.3.27Z",
    style: {
      fill: "none",
      transformOrigin: "273.13px 56.055px"
    },
    id: "elp3kpcopjkhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.92,55.4l-.32.24Z",
    style: {
      fill: "none",
      transformOrigin: "273.76px 55.52px"
    },
    id: "elm68ct9ghmim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,56.5c-.09.1-.19.19-.28.3C272.49,56.69,272.59,56.6,272.68,56.5Z",
    style: {
      fill: "none",
      transformOrigin: "272.54px 56.65px"
    },
    id: "elw748h25725n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.62,81.87c.19.49.39,1,.6,1.46C272,82.84,271.81,82.36,271.62,81.87Z",
    style: {
      fill: "none",
      transformOrigin: "271.92px 82.6px"
    },
    id: "elh31ru29iy25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.31,83.56c.24.54.48,1.07.74,1.6C272.79,84.63,272.55,84.1,272.31,83.56Z",
    style: {
      fill: "none",
      transformOrigin: "272.68px 84.36px"
    },
    id: "elzm0pu9al9bb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,97.57c-.33-.35-.65-.71-1-1.08h0l-.21-.24h0c-.53-.61-1-1.23-1.54-1.87l-.16-.21h0c-.4-.51-.78-1-1.16-1.57h0l-.17-.23h0c-.36-.52-.71-1-1.05-1.58-.09-.13-.17-.26-.25-.39h0c-.28-.44-.55-.88-.81-1.33a2.61,2.61,0,0,1-.17-.28h0c-.3-.51-.59-1-.87-1.55h0l-.2-.4c-.22-.41-.43-.83-.64-1.25l-.2-.42c-.26-.53-.5-1.06-.74-1.6l-.09-.23c-.21-.49-.41-1-.6-1.46l-.17-.44h0c-.22-.58-.43-1.16-.62-1.74,0,0,0-.09-.05-.14h0c-.2-.6-.38-1.2-.55-1.8h0l-.09-.34c-.2-.7-.37-1.4-.52-2.09h0c0-.16-.06-.31-.1-.46l-.15-.82c0-.17-.07-.34-.09-.52v0c0-.28-.09-.56-.13-.84s-.05-.33-.07-.5c-.08-.6-.13-1.2-.18-1.79,0-.13,0-.26,0-.38,0-.61-.06-1.22-.06-1.82,0-.41,0-.82,0-1.21l0-.45c0-.24,0-.49.06-.72s0-.3.05-.45,0-.46.08-.68.06-.31.08-.46.07-.41.11-.61.07-.31.1-.47.09-.37.13-.56.09-.3.13-.45.1-.35.16-.52l.15-.44c.06-.16.11-.33.18-.49s.12-.27.17-.41.13-.31.2-.46.13-.26.2-.39.14-.29.22-.43l.22-.36.24-.41.24-.34c.09-.12.17-.25.27-.37s.17-.21.26-.32.18-.23.28-.34.19-.2.28-.3l.3-.31.3-.27.32-.28.32-.24.34-.25.33-.22a10.35,10.35,0,0,1,3.35-1.35c-2.25,2.53-3.57,6.38-3.59,11.34,0,.6,0,1.21.06,1.82,0,.13,0,.25,0,.38,0,.59.1,1.19.18,1.79,0,.17.05.34.07.5s.08.56.13.84.06.38.1.57l.15.82c0,.15.07.3.1.46.15.69.32,1.39.51,2.09a3.57,3.57,0,0,1,.1.35c.17.59.35,1.19.55,1.79,0,0,0,.1.05.14.19.59.4,1.17.62,1.74.06.15.11.3.17.44.19.49.39,1,.6,1.46l.09.23c.24.54.48,1.07.74,1.6.06.14.13.28.2.42.21.42.42.84.64,1.26l.2.39c.28.52.57,1,.87,1.55.05.1.11.19.17.29.26.44.53.89.81,1.33l.24.38c.35.53.7,1.06,1.06,1.58l.17.23c.38.54.76,1.06,1.16,1.58l.16.21c.5.64,1,1.26,1.54,1.87l.2.24,1,1.09.06.06c.35.37.71.74,1.07,1.09.07.08.15.15.23.23.47.45.94.9,1.43,1.33l.13.12c.5.44,1,.85,1.52,1.26l.3.23c.5.39,1,.76,1.54,1.12l.27.18c.55.36,1.1.71,1.65,1s.89.49,1.33.72l.37.18,1,.46.35.15.92.35.23.08c.38.13.76.25,1.13.35l.66.16.3.08c.32.07.63.12.94.17a11.44,11.44,0,0,0,1.4.14l.28,0c.41,0,.81,0,1.21,0l.2,0a9.5,9.5,0,0,0,.95-.11l.29,0,.3-.07a10.25,10.25,0,0,1-2.59,2.12h0l-.1.05-.07,0c-.25.14-.51.26-.77.38h0l-.27.11q-.41.17-.84.3l-.15,0c-.33.09-.67.17-1,.23h0l-.27,0c-.31,0-.61.08-.93.11l-.24,0c-.39,0-.79,0-1.19,0h0l-.26,0h0l-.66,0-.76-.09-.48-.09-.46-.09-.28-.07-.08,0-.59-.14c-.37-.11-.74-.22-1.11-.35l-.23-.08-.93-.35h0l-.33-.14h0q-.5-.21-1-.45l-.22-.11a.8.8,0,0,1-.16-.08c-.44-.22-.88-.45-1.33-.71s-1.1-.67-1.64-1l-.08,0-.2-.13c-.52-.36-1-.73-1.54-1.12l-.19-.15-.11-.08c-.51-.41-1-.83-1.52-1.26a.6.6,0,0,1-.08-.08l-.05,0c-.49-.42-1-.87-1.43-1.32l-.23-.23c-.36-.35-.72-.72-1.07-1.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "287.9px 80.32px"
    },
    id: "ell8fs0kz7m7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.7 86.16 306.7 87.45 310.33 89.54 310.33 88.25 306.7 86.16",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "308.515px 87.85px"
    },
    id: "el1ib72a3raqz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.35 59.04 276.79 59.82 279.93 63.73 280.49 62.94 277.35 59.04",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "278.64px 61.385px"
    },
    id: "el8163m64az2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4,90.67c0,13.27-9.43,18.62-21,12S271.55,79.8,271.58,66.53s9.43-18.62,21-12S313.44,77.4,313.4,90.67ZM283,77.86a1.25,1.25,0,0,0,.52.68.47.47,0,0,0,.22.07l8.88.7a.29.29,0,0,0,.33-.13l5.81-9.85a1,1,0,0,0-.25-1,1,1,0,0,0-.25-.21c-.2-.11-.4-.1-.5.07l-5.71,9.69-8.75-.69c-.28,0-.42.28-.3.68m17.08-8.7,1.82-2.56-1-1.2L299.15,68l1,1.2m.75,32.38,1-.08L300,96.8l-1,.08,1.8,4.66M277.29,80.65l3.15-.27-.55-1.44-3.16.27.56,1.44m30.34,17.52.56-.79-3.14-3.91-.56.79,3.14,3.91M277.35,59l-.56.78,3.14,3.91.56-.79L277.35,59M305.1,78.26l3.15-.27-.56-1.43-3.15.26.56,1.44m-21-22.6-1,.08,1.8,4.66,1-.08-1.81-4.66M284,91.8l1.83-2.57-1-1.19L283,90.6l1,1.2M278.28,71V69.75l-3.63-2.09v1.28l3.63,2.1m32.05,17.22-3.63-2.1v1.29l3.63,2.09V88.26M291.88,98.78l1.11.64V95.25l-1.11-.65v4.18m1.23-40.36L292,57.78V62l1.11.65,0-4.18",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "292.49px 78.6px"
    },
    id: "elpto6fi0fdck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.99 57.78 291.98 61.95 293.09 62.6 293.11 58.42 291.99 57.78",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "292.545px 60.19px"
    },
    id: "ely8vgfa3amaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.98 65.4 299.15 67.96 300.12 69.16 301.94 66.6 300.98 65.4",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.545px 67.28px"
    },
    id: "el3uw7p8ge9eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.69 76.56 304.54 76.82 305.1 78.26 308.25 77.99 307.69 76.56",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "306.395px 77.41px"
    },
    id: "eljdrk0pbd6a8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.05 93.47 304.49 94.26 307.63 98.17 308.19 97.38 305.05 93.47",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "306.34px 95.82px"
    },
    id: "el74n49kzldvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.04 96.8 299.07 96.88 300.87 101.54 301.84 101.46 300.04 96.8",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.455px 99.17px"
    },
    id: "elrami84xmyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.89 94.6 291.88 98.78 292.99 99.42 293 95.25 291.89 94.6",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "292.44px 97.01px"
    },
    id: "el6z8nso0962k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.87 88.04 283.04 90.6 284 91.8 285.83 89.23 284.87 88.04",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "284.435px 89.92px"
    },
    id: "elqskrly5qbrg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.88 78.94 276.73 79.21 277.29 80.65 280.44 80.38 279.88 78.94",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "278.585px 79.795px"
    },
    id: "elmels90ngoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.65 67.66 274.65 68.94 278.28 71.04 278.28 69.75 274.65 67.66",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "276.465px 69.35px"
    },
    id: "eldpa1afzprz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.1 55.66 283.14 55.74 284.94 60.4 285.91 60.32 284.1 55.66",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "284.525px 58.03px"
    },
    id: "ela14pmbp7ny9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.49,78a.47.47,0,0,0-.22-.07l-.18,0-8.75-.69c-.28,0-.42.28-.3.68a1.25,1.25,0,0,0,.52.68.47.47,0,0,0,.22.07l8.88.7h0c.28,0,.41-.27.29-.67A1.2,1.2,0,0,0,292.49,78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "287.996px 78.305px"
    },
    id: "elakahd8lsupf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.3,68.11c-.2-.11-.4-.1-.5.07l-5.71,9.69.18,0a.47.47,0,0,1,.22.07,1.2,1.2,0,0,1,.51.68c.12.4,0,.7-.29.67h0a.29.29,0,0,0,.33-.13l5.81-9.85a1,1,0,0,0-.25-1A1,1,0,0,0,298.3,68.11Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "295.492px 73.6697px"
    },
    id: "el6pbf625aew9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,107l.33-.26a3.38,3.38,0,0,0,.35-.31c.11-.09.22-.18.32-.28l.33-.34.3-.32a3.79,3.79,0,0,0,.31-.37c.09-.11.19-.22.28-.34s.19-.27.28-.4.18-.24.26-.37.18-.29.26-.44.17-.26.24-.39.16-.31.24-.47l.22-.42.21-.5c.06-.15.13-.29.19-.44s.13-.36.19-.54.12-.31.17-.46.11-.38.16-.57.1-.32.14-.49.1-.39.14-.59l.12-.52c0-.21.07-.43.11-.64l.09-.52.09-.74.06-.47.06-.85,0-.41q0-.64,0-1.32c0-.65,0-1.3-.06-2h0a.62.62,0,0,1,0-.13c-.05-.73-.11-1.47-.21-2.22h0l0-.25-.18-1.21h0c0-.2-.07-.4-.11-.61h0c-.06-.29-.11-.59-.17-.89h0l0-.14a44.67,44.67,0,0,0-1.34-4.94h0a51,51,0,0,0-2.6-6.37l-.06-.13h0c-.58-1.17-1.19-2.33-1.85-3.46h0l-.18-.31h0c-.3-.51-.61-1-.92-1.5l-.22-.35h0c-.86-1.33-1.76-2.61-2.72-3.84l0,0h0q-1.41-1.81-3-3.47h0c-.39-.42-.79-.82-1.19-1.23h0l-.2-.18c-.52-.52-1.05-1-1.6-1.5h0l-.06,0c-.56-.5-1.14-1-1.72-1.44h0l-.31-.25h0c-.55-.42-1.1-.82-1.67-1.2h0l-.06-.05c-.36-.24-.72-.48-1.08-.7s-.62-.39-.94-.57c-.48-.28-1-.53-1.43-.77h0l0,0a23.55,23.55,0,0,0-4.27-1.68h0l-.39-.1-.62-.15h0l-.43-.08-.58-.1h-.05l-.42,0-.74-.08h-.06l-.23,0a14.41,14.41,0,0,0-1.61,0h0l-.23,0h0c-.34,0-.68.06-1,.11h0a10.53,10.53,0,0,0-1.4.3h-.08l-.09,0c-.31.1-.61.21-.91.33h0l-.14.06c-.41.18-.82.37-1.21.59l0,0,5.54-3.22.12-.07.15-.08c.27-.14.55-.28.83-.4a1.19,1.19,0,0,1,.16-.08l.13,0q.5-.2,1-.36h0a10.88,10.88,0,0,1,1.13-.26l.13,0,.18,0a8.86,8.86,0,0,1,1-.12l.17,0h.05a11.43,11.43,0,0,1,1.31,0h.13l.43,0,.3,0c.3,0,.61.06.92.11h0l1,.19.32.08.65.16.06,0c.4.11.81.23,1.22.37l.25.1c.33.11.66.24,1,.38l.14.05.25.11c.35.15.71.32,1.07.49l.41.2c.47.24,1,.49,1.43.77s1.19.72,1.78,1.12l.3.2c.56.38,1.12.78,1.67,1.2l.31.25c.56.44,1.11.89,1.65,1.37a.86.86,0,0,1,.14.13c.53.46,1,.94,1.55,1.44l.15.14.1.1c.39.38.77.77,1.15,1.18l.06.06c.36.39.71.78,1.06,1.18l.1.11.12.15c.57.66,1.13,1.33,1.67,2l0,.06a1.67,1.67,0,0,1,.12.16q.65.84,1.26,1.71l.13.17a.41.41,0,0,1,.05.09c.4.55.78,1.12,1.15,1.7a.91.91,0,0,0,.11.16l.15.26c.3.47.59,1,.88,1.43l.13.22a.41.41,0,0,1,0,.09c.33.56.64,1.12.94,1.68l.07.14.15.28.69,1.36c0,.09.09.19.14.28s.05.12.08.17c.27.58.54,1.16.79,1.74l0,0a1.34,1.34,0,0,0,.07.18c.23.53.44,1.06.65,1.59,0,.09.07.17.11.26s.05.14.07.22c.24.62.47,1.25.68,1.88v0l0,.11q.33,1,.6,2l.07.25a.65.65,0,0,1,0,.13c.2.76.39,1.51.55,2.26a1.46,1.46,0,0,1,0,.2l.06.3c.06.29.11.59.17.88s.07.41.11.62.09.61.13.91c0,.14.05.28.07.43a.45.45,0,0,0,0,.11c.08.65.14,1.3.19,1.94,0,.14,0,.27,0,.41,0,.66.07,1.31.07,2,0,7.13-2.54,12.14-6.59,14.5l-5.54,3.22.35-.23c.12-.07.24-.14.35-.22Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "295.785px 77.9906px"
    },
    id: "elxzmtxqpq2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.12,67.16c0,14.34,10,31.81,22.53,39,6.46,3.73,12.3,4,16.43,1.35.12-.07.24-.14.35-.22l.38-.28.33-.26a3.38,3.38,0,0,0,.35-.31c.11-.09.22-.18.32-.28l.33-.34.3-.32a3.79,3.79,0,0,0,.31-.37c.09-.11.19-.22.28-.34s.19-.27.28-.4.18-.24.26-.37.18-.29.26-.44.17-.26.24-.39.16-.31.24-.47l.22-.42.21-.5c.06-.15.13-.29.19-.44s.13-.36.19-.54.12-.31.17-.46.11-.38.16-.57.1-.32.14-.49.1-.39.14-.59l.12-.52c0-.21.07-.43.11-.64l.09-.52.09-.74.06-.47.06-.85,0-.41q0-.64,0-1.32c0-.65,0-1.3-.06-2v-.13c-.05-.73-.11-1.47-.21-2.22l0-.25-.18-1.21c0-.2-.07-.4-.11-.61s-.11-.59-.17-.89l0-.14a44.67,44.67,0,0,0-1.34-4.94h0a51,51,0,0,0-2.6-6.37l-.06-.13c-.58-1.17-1.19-2.33-1.85-3.46l-.18-.31c-.3-.51-.61-1-.92-1.5l-.22-.35c-.86-1.33-1.76-2.61-2.72-3.84l0,0q-1.41-1.81-3-3.47h0c-.39-.42-.79-.82-1.19-1.23l-.2-.18c-.52-.52-1.05-1-1.6-1.5l-.06,0c-.56-.5-1.14-1-1.72-1.44a3.92,3.92,0,0,1-.32-.25c-.55-.42-1.1-.82-1.67-1.2l-.06-.05c-.36-.24-.72-.48-1.08-.7s-.62-.39-.94-.57c-.48-.28-1-.53-1.43-.77l0,0a23.55,23.55,0,0,0-4.27-1.68l-.41-.1-.62-.15c-.15,0-.3-.06-.45-.09l-.58-.1-.47-.06-.74-.08-.29,0a14.41,14.41,0,0,0-1.61,0l-.26,0c-.34,0-.68.06-1,.11h0a10.53,10.53,0,0,0-1.4.3l-.17,0c-.31.1-.61.21-.91.33l-.16.06c-.41.18-.82.37-1.21.59C269.67,55,267.14,60,267.12,67.16Zm14.39,30.48-.06-.07c-.33-.35-.65-.71-1-1.08l-.21-.24c-.53-.61-1-1.23-1.54-1.87l-.16-.21c-.4-.52-.78-1-1.16-1.58l-.17-.23c-.36-.52-.71-1-1.05-1.58-.09-.13-.17-.26-.25-.39-.28-.43-.55-.88-.81-1.33a2.61,2.61,0,0,1-.17-.28c-.3-.51-.59-1-.87-1.55l-.2-.4c-.22-.41-.43-.83-.64-1.25l-.2-.42c-.26-.53-.5-1.06-.74-1.6l-.09-.23c-.21-.49-.41-1-.6-1.46l-.17-.44c-.22-.58-.43-1.16-.62-1.74,0,0,0-.09-.05-.14-.2-.6-.38-1.2-.55-1.8l-.09-.34c-.2-.7-.37-1.4-.52-2.09,0-.16-.06-.31-.1-.46l-.15-.82c0-.17-.07-.34-.09-.52s-.1-.59-.14-.89-.05-.33-.07-.5c-.08-.6-.13-1.2-.18-1.79,0-.13,0-.26,0-.38,0-.61-.06-1.22-.06-1.82,0-.41,0-.82,0-1.21l0-.45c0-.24,0-.49.06-.72s0-.3.05-.45,0-.46.08-.68.06-.31.08-.46.07-.41.11-.61.07-.31.1-.47.09-.37.13-.56.09-.3.13-.45.1-.35.16-.52l.15-.44c.06-.16.11-.33.18-.49s.12-.27.17-.41.13-.31.2-.46.13-.26.2-.39.14-.29.22-.43l.22-.36.24-.41.24-.34c.09-.12.17-.25.27-.37s.17-.21.26-.32.18-.23.28-.34.19-.2.28-.3l.3-.31.3-.27.32-.28.32-.24.34-.25.33-.22a10.35,10.35,0,0,1,3.35-1.35c3.37-.72,7.45.07,11.85,2.61,11.54,6.66,20.88,22.82,20.84,36.09,0,5-1.33,8.8-3.58,11.33a10.25,10.25,0,0,1-2.59,2.12h0l-.1.05c-.28.15-.57.29-.86.42l-.27.11q-.41.17-.84.3l-.15,0c-.34.09-.69.17-1,.24l-.27,0c-.31,0-.61.08-.93.11l-.24,0c-.39,0-.8,0-1.21,0l-.26,0-.66,0-.76-.09-.48-.09-.46-.09c-.12,0-.24-.06-.36-.09l-.59-.14a21.37,21.37,0,0,1-2.28-.79l-.33-.14c-.41-.18-.81-.36-1.22-.57a.8.8,0,0,1-.16-.08c-.44-.22-.88-.45-1.33-.71s-1.1-.67-1.64-1l-.08,0c-.65-.44-1.3-.91-1.93-1.4l-.11-.08c-.54-.43-1.08-.87-1.6-1.34l-.05,0c-.49-.42-1-.87-1.43-1.32l-.23-.23C282.22,98.38,281.86,98,281.51,97.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "289.69px 80.2569px"
    },
    id: "elwpfs4yhhv2d",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-2",
    className: "animable",
    style: {
      transformOrigin: "441.94px 140.18px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.09 143.34 456.66 160.99 456.59 184.35 426.03 166.7 426.09 143.34",
    style: {
      fill: "none",
      transformOrigin: "441.345px 163.845px"
    },
    id: "elrt5tecxi4mo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.09 143.34 426.03 166.7 423.2 168.35 423.27 141.72 426.09 143.34",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "424.645px 155.035px"
    },
    id: "elbtqu0ohdvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.59 184.35 456.58 187.62 423.2 168.35 426.03 166.7 456.59 184.35",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "439.895px 177.16px"
    },
    id: "el0xec4y06r61",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,170.3,460,193.53l.1-34.49-40.23-23.23Zm3.44-2,.07-26.64,2.82,1.63L456.66,161l-.07,23.36v3.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "439.93px 164.67px"
    },
    id: "el7k4j96dngte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.86 135.81 422.69 134.17 462.92 157.4 460.09 159.04 419.86 135.81",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "441.39px 146.605px"
    },
    id: "el7btygfrt6du",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.92 157.4 462.82 191.88 459.99 193.53 460.09 159.04 462.92 157.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "461.455px 175.465px"
    },
    id: "ele93cvqhdegg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.29 96.01 457.86 113.66 457.79 137.01 427.23 119.37 427.29 96.01",
    style: {
      fill: "none",
      transformOrigin: "442.545px 116.51px"
    },
    id: "eldc8ne5djk3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.29 96.01 427.23 119.37 424.39 121.01 424.47 94.38 427.29 96.01",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "425.84px 107.695px"
    },
    id: "el9lvw3a0unwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.79 137.01 457.78 140.29 424.39 121.01 427.23 119.37 457.79 137.01",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "441.09px 129.83px"
    },
    id: "elbbh7a3i94y8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,123l40.23,23.23.1-34.49L421.06,88.48Zm3.43-2,.08-26.63L427.29,96l30.57,17.65L457.79,137v3.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.165px 117.355px"
    },
    id: "elp8fzmno7qjc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.06 88.48 423.89 86.83 464.12 110.06 461.29 111.71 421.06 88.48",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "442.59px 99.27px"
    },
    id: "elqtnkmx6twf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.12 110.06 464.02 144.55 461.19 146.19 461.29 111.71 464.12 110.06",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "462.655px 128.125px"
    },
    id: "ello9vo8sqegn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.81 152.21 427.47 158.78 427.45 165.19 455.17 181.19 455.19 174.78 449.91 164.29 445.17 167.97 446.84 173.18 444.41 168.56 435.81 152.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "441.32px 166.7px"
    },
    id: "el41udmm098z5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.91,155.44c-1.3-.75-2.37-.14-2.37,1.36a5.17,5.17,0,0,0,2.36,4.07c1.3.76,2.36.15,2.37-1.35A5.2,5.2,0,0,0,444.91,155.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.905px 158.158px"
    },
    id: "el386ncckfwkt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437 104.88 428.67 111.44 428.65 117.85 456.37 133.86 456.39 127.45 451.11 116.95 446.36 120.64 448.04 125.85 445.61 121.22 437 104.88",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "442.52px 119.37px"
    },
    id: "elnozjk92435j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.11,108.11c-1.31-.75-2.37-.15-2.37,1.35a5.18,5.18,0,0,0,2.35,4.08c1.31.75,2.37.15,2.37-1.35A5.18,5.18,0,0,0,446.11,108.11Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "446.1px 110.825px"
    },
    id: "elh2trv6v1pha",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable animator-active",
    style: {
      transformOrigin: "369.09px 122.312px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.5,69.11l59.87,34.62a6.69,6.69,0,0,1,3.34,5.77v60.2a6.57,6.57,0,0,1-10,5.41l-25-14.84-.54.87s-.05.05-.08.08h0l-.06,0h0c-1,.65-2.69,1.57-3.07,1.77v0a.36.36,0,0,1-.45-.22l-2.18-6.18h0L335.8,140.57a6.65,6.65,0,0,1-3.35-5.77V74.52C332.45,69.72,339.51,67.39,342.5,69.11Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "369.08px 122.312px"
    },
    id: "elbkt5rk9kumg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.45,107.77Z",
    style: {
      fill: "none",
      transformOrigin: "396.45px 107.77px"
    },
    id: "eltv1xfoz5qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr7lmd67j0f",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.08,161.14s-.05.05-.08.08h0l-.06,0h0c-1,.65-2.69,1.57-3.07,1.77v0a.31.31,0,0,0,.22-.15l2.11-3.42-.42-.24h0l1.86,1.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "368.755px 161.085px"
    },
    className: "animable",
    id: "el96qhxr74l3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el39q8hmf6u4t",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.23,110a6.86,6.86,0,0,0-1.78-2.23h0a6.08,6.08,0,0,0-.81-.55L335.77,72.59a2.22,2.22,0,0,0-3.32,1.93c0-4.8,7.06-7.13,10.05-5.41l59.87,34.62a6.71,6.71,0,0,1,2.48,2.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "368.65px 89.273px"
    },
    className: "animable",
    id: "elg35zpgkjpac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhzwish4dx6j",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399,173.19V113a6.36,6.36,0,0,0-.75-3l6.62-3.76a6.67,6.67,0,0,1,.86,3.26v60.2a6.57,6.57,0,0,1-10,5.41A2.22,2.22,0,0,0,399,173.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "400.73px 141.159px"
    },
    className: "animable",
    id: "elkqtgdcp27br"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,97.32l34.75,20.06-2.09,23.82c-.12,1.45-1.24,2-2.57,1.2L350.58,127a4.87,4.87,0,0,1-1.37-1.25l.05.68a10.22,10.22,0,0,0,4.6,7.5l1.17.67a4.53,4.53,0,0,1,1.25.5,6.17,6.17,0,0,1,1.25,1L370,143.3a4.14,4.14,0,0,1,1.25.5,6.5,6.5,0,0,1,1.25.94l2.65,1.53a2.26,2.26,0,0,1,1,1.78c0,.65-.47.91-1,.59l-.21-.12a7.08,7.08,0,0,1,.46,2.47c0,2.64-1.87,3.71-4.18,2.38a9.18,9.18,0,0,1-4.15-7.19,3.67,3.67,0,0,1,.48-1.93l-7.62-4.4a7.41,7.41,0,0,1,.46,2.47c0,2.65-1.88,3.71-4.18,2.38a9.12,9.12,0,0,1-4.15-7.19,3.61,3.61,0,0,1,.53-2,15.08,15.08,0,0,1-5.42-10l-2.36-32a4.54,4.54,0,0,0-2.05-3.33l-4.3-2.49a2.26,2.26,0,0,1-1-1.77c0-.66.47-.92,1-.59l4.3,2.48a9.11,9.11,0,0,1,4.09,6.67Zm18.19,33.91.05-19.08a3.08,3.08,0,0,0-1.39-2.41c-.77-.44-1.39-.09-1.4.8l-.05,19.08A3.09,3.09,0,0,0,363.9,132c.77.44,1.4.08,1.4-.8m6,3.48.05-19.08a3.08,3.08,0,0,0-1.39-2.41c-.77-.44-1.4-.09-1.4.8l0,19.08a3.06,3.06,0,0,0,1.39,2.41c.77.44,1.39.08,1.4-.8m6,3.48.06-19.08A3.08,3.08,0,0,0,376,116.7c-.77-.44-1.4-.09-1.4.8l-.05,19.08A3.06,3.06,0,0,0,376,139c.76.44,1.39.08,1.39-.8m-18.08-10.44.05-19.08a3,3,0,0,0-1.39-2.41c-.77-.44-1.39-.09-1.4.8l0,19.08a3.09,3.09,0,0,0,1.39,2.41c.77.44,1.4.08,1.4-.8m-6-3.48.06-19.08a3.1,3.1,0,0,0-1.39-2.41c-.77-.44-1.4-.09-1.4.8l-.06,19.08a3.06,3.06,0,0,0,1.39,2.4c.77.45,1.4.09,1.4-.79m3,13.85c-.86-.5-1.56-.1-1.57.89a3.46,3.46,0,0,0,1.56,2.7c.87.5,1.56.1,1.57-.89a3.43,3.43,0,0,0-1.56-2.7m15,8.67c-.86-.5-1.56-.1-1.56.89a3.42,3.42,0,0,0,1.55,2.7c.86.5,1.57.1,1.57-.9a3.44,3.44,0,0,0-1.56-2.69",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "359.66px 119.564px"
    },
    id: "el1t0zj3z372p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.81,117.89a3,3,0,0,1,1.07,1.12c.59,1,.59,2.12,0,2.45l-8.83,5a1.06,1.06,0,0,1-1.07-.11,3.13,3.13,0,0,1-1.07-1.12l-4.32-7.5c-.6-1-.59-2.12,0-2.46a1.08,1.08,0,0,1,1.07.11,3.13,3.13,0,0,1,1.07,1.12L383,122.2l7.76-4.42A1.06,1.06,0,0,1,391.81,117.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "385.233px 120.867px"
    },
    id: "el1y5mncry1k9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25,108.64c5.89,3.4,10.64,11.64,10.62,18.4s-4.8,9.48-10.69,6.08-10.63-11.62-10.61-18.39S379.37,105.25,385.25,108.64ZM384,126.5l8.83-5c.6-.33.6-1.43,0-2.45a3,3,0,0,0-1.07-1.12,1.06,1.06,0,0,0-1.07-.11L383,122.2l-3.26-5.66a3.13,3.13,0,0,0-1.07-1.12,1.08,1.08,0,0,0-1.07-.11c-.59.34-.6,1.43,0,2.46l4.32,7.5a3.13,3.13,0,0,0,1.07,1.12,1.06,1.06,0,0,0,1.07.11",
    style: {
      fill: "#FF725E",
      transformOrigin: "385.22px 120.882px"
    },
    id: "elpslxx0yed4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elybb6r0eike",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.25,108.64c5.89,3.4,10.64,11.64,10.62,18.4s-4.8,9.48-10.69,6.08-10.63-11.62-10.61-18.39S379.37,105.25,385.25,108.64ZM384,126.5l8.83-5c.6-.33.6-1.43,0-2.45a3,3,0,0,0-1.07-1.12,1.06,1.06,0,0,0-1.07-.11L383,122.2l-3.26-5.66a3.13,3.13,0,0,0-1.07-1.12,1.08,1.08,0,0,0-1.07-.11c-.59.34-.6,1.43,0,2.46l4.32,7.5a3.13,3.13,0,0,0,1.07,1.12,1.06,1.06,0,0,0,1.07.11",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "385.22px 120.882px"
    },
    className: "animable",
    id: "elr3uyv9kvgos"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    className: "animable",
    style: {
      transformOrigin: "176.62px 213.553px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.31,79.64h0c-.7-2.47-5.72-7.17-10.72-7.07a4.32,4.32,0,0,0-1.4.28L84.2,128a9.15,9.15,0,0,0-3.73,4,9.26,9.26,0,0,0-1,4.07V345.92c0,5.34,6.16,10.44,11.95,8l0,0a2,2,0,0,0,.38-.15l97-55.28a9.29,9.29,0,0,0,4.68-8.06V80.65A2.25,2.25,0,0,0,193.31,79.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "136.477px 213.558px"
    },
    id: "elzvd4kkt5h5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,158.27a4.62,4.62,0,0,1,2.34-4L185.45,103a2.32,2.32,0,0,1,3.47,2v169.2a4.67,4.67,0,0,1-2.34,4L96.51,329.56a2.32,2.32,0,0,1-3.47-2Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "140.96px 216.28px"
    },
    id: "el622wsst6hkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnlzgc5ebb6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,158.27a4.62,4.62,0,0,1,2.34-4L185.45,103a2.32,2.32,0,0,1,3.47,2v169.2a4.67,4.67,0,0,1-2.34,4L96.51,329.56a2.32,2.32,0,0,1-3.47-2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "140.96px 216.28px"
    },
    className: "animable",
    id: "elmloirrt27p"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellfuz2dvu80o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,158.27a4.62,4.62,0,0,1,2.34-4L185.45,103a2.32,2.32,0,0,1,3.47,2v169.2a4.67,4.67,0,0,1-2.34,4L96.51,329.56a2.32,2.32,0,0,1-3.47-2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "140.96px 216.28px"
    },
    className: "animable",
    id: "el1kms9khjcud"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elugrmr8yz7oc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.51,136.09V345.92c0,5.34,6.16,10.44,11.95,8l0,0a2.3,2.3,0,0,1-3.09-2.16V141.89A9.25,9.25,0,0,1,90,136.77L80.47,132A9.26,9.26,0,0,0,79.51,136.09Z",
    style: {
      opacity: 0.3,
      transformOrigin: "85.485px 243.274px"
    },
    className: "animable",
    id: "el3pfr6sawvz4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7gjzuhymjvg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.6,72.56a4.32,4.32,0,0,0-1.4.28L84.2,128a9.15,9.15,0,0,0-3.73,4L90,136.77a9.23,9.23,0,0,1,3.13-3l97-55.18a2.3,2.3,0,0,1,3.22,1h0C192.62,77.16,187.6,72.46,182.6,72.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "136.91px 104.664px"
    },
    className: "animable",
    id: "elb4t5y69jdl9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.93,113.28c.69-.39,1.25-.08,1.25.7a2.78,2.78,0,0,1-1.24,2.15l-19,11c-.68.4-1.23.07-1.23-.72a2.71,2.71,0,0,1,1.22-2.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.445px 120.206px"
    },
    id: "elr6wsc4g5di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,127.09c.68-.39,1.23-.08,1.23.71a2.75,2.75,0,0,1-1.23,2.14c-.68.39-1.24.07-1.24-.71A2.7,2.7,0,0,1,129,127.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.995px 128.514px"
    },
    id: "elx57gkigaac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,111.69c1.36-.79,2.46-.16,2.46,1.4a5.42,5.42,0,0,1-2.45,4.27c-1.36.79-2.49.15-2.49-1.42A5.44,5.44,0,0,1,141.2,111.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.19px 114.524px"
    },
    id: "elpi1gg7zzgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.2,309.22c2.78-1.6,5-.32,5,2.86a11.08,11.08,0,0,1-5,8.71c-2.77,1.6-5.07.29-5.08-2.9A11.08,11.08,0,0,1,141.2,309.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.16px 315.002px"
    },
    id: "elyhu3ym9veol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.62 100.34 221.38 127.53 209.44 134.43 176.69 107.24 188.62 100.34",
    style: {
      fill: "#FF725E",
      transformOrigin: "199.035px 117.385px"
    },
    id: "el46xhoxcw1i2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.75 114.14 197.5 141.32 185.56 148.22 152.82 121.04 164.75 114.14",
    style: {
      fill: "#FF725E",
      transformOrigin: "175.16px 131.18px"
    },
    id: "elrvz3di3l3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.82 121.04 185.56 148.22 173.62 155.12 140.88 127.94 152.82 121.04",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "163.22px 138.08px"
    },
    id: "el92gfwv5hb5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.69 107.24 209.44 134.43 197.5 141.32 164.75 114.14 176.69 107.24",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "187.095px 124.28px"
    },
    id: "eleterormdk75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.01 141.73 149.74 168.91 137.8 175.81 105.07 148.63 117.01 141.73",
    style: {
      fill: "#FF725E",
      transformOrigin: "127.405px 158.77px"
    },
    id: "elbj4d377966",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.88 127.94 173.62 155.12 161.68 162.01 128.94 134.83 140.88 127.94",
    style: {
      fill: "#FF725E",
      transformOrigin: "151.28px 144.975px"
    },
    id: "elqls84hce9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.91 155.66 105.07 148.63 137.8 175.81 125.61 182.85 92.91 155.66",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "115.355px 165.74px"
    },
    id: "el28fd50yh9hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.94 134.83 161.68 162.01 149.74 168.91 117.01 141.73 128.94 134.83",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.345px 151.87px"
    },
    id: "elmkm48hnadqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38,127.53l-11.94,6.9h0a4.61,4.61,0,0,0,6.91,4h0a10.09,10.09,0,0,0,5-8.72Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "215.41px 133.287px"
    },
    id: "el0xovdnvk8xc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.44,134.43l-11.94,6.9h0a4.61,4.61,0,0,0,6.91,4h0a10.07,10.07,0,0,0,5-8.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "203.47px 140.187px"
    },
    id: "elyxldxnaxn5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,141.33l-11.94,6.89h0a4.61,4.61,0,0,0,6.91,4h0a10.07,10.07,0,0,0,5-8.72Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "191.53px 147.082px"
    },
    id: "elttqmqz7ff4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.56,148.22l-11.94,6.9h0a4.6,4.6,0,0,0,6.91,4h0a10.06,10.06,0,0,0,5-8.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.59px 153.981px"
    },
    id: "elkrztpraybr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,155.12,161.68,162h0a4.61,4.61,0,0,0,6.91,4h0a10.07,10.07,0,0,0,5-8.72Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "167.65px 160.867px"
    },
    id: "elhg03te5nqlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.68,162l-11.94,6.89h0a4.61,4.61,0,0,0,6.91,4h0a10.09,10.09,0,0,0,5-8.72Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "155.71px 167.752px"
    },
    id: "eljui6w1fxiyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.74,168.91l-11.94,6.9h0a4.6,4.6,0,0,0,6.91,4h0a10,10,0,0,0,5-8.72Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "143.77px 174.671px"
    },
    id: "ely3vzuc63aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellneo9ftlxfs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.38,127.53l-11.94,6.9h0a4.61,4.61,0,0,0,6.91,4h0a10.09,10.09,0,0,0,5-8.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "215.41px 133.287px"
    },
    className: "animable",
    id: "el2tr2l211jut"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elga9mds470lr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.5,141.33l-11.94,6.89h0a4.61,4.61,0,0,0,6.91,4h0a10.07,10.07,0,0,0,5-8.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "191.53px 147.082px"
    },
    className: "animable",
    id: "elpvj683rna0k"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmympyu0dxjb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.62,155.12,161.68,162h0a4.61,4.61,0,0,0,6.91,4h0a10.07,10.07,0,0,0,5-8.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "167.65px 160.867px"
    },
    className: "animable",
    id: "elc1xbvkamm2j"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln0m8pcm7hhh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.74,168.91l-11.94,6.9h0a4.6,4.6,0,0,0,6.91,4h0a10,10,0,0,0,5-8.72Z",
    style: {
      opacity: 0.2,
      transformOrigin: "143.77px 174.671px"
    },
    className: "animable",
    id: "elx2vqcm13uoi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.8,175.81l-12.19,7h0a4.6,4.6,0,0,0,6.9,4h0a10.58,10.58,0,0,0,5.29-9.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "131.705px 181.618px"
    },
    id: "ell261yaehejd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.72,211a29.41,29.41,0,0,0-10.14,3.13,32.41,32.41,0,0,0-15.74,18.12,29.48,29.48,0,0,0-1.67,10.48,49.63,49.63,0,0,1,3.39-9.78,41.63,41.63,0,0,1,14.95-17.22A50.12,50.12,0,0,1,151.72,211Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "137.941px 226.865px"
    },
    id: "eljhz9nfthgao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.38,263.36a18.6,18.6,0,0,1-5.71-1,16.08,16.08,0,0,1-9.42-8.27,18.34,18.34,0,0,1-1.73-5.53,13,13,0,0,0,.77,5.94,14,14,0,0,0,10.1,8.86A13,13,0,0,0,142.38,263.36Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "133.915px 256.135px"
    },
    id: "el0g32qg3ay0s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,231.2a45.46,45.46,0,0,1-.12,8A40.5,40.5,0,0,1,152,256.14a45.41,45.41,0,0,1-4.79,6.45,25.07,25.07,0,0,0,6-5.64,29.1,29.1,0,0,0,6-17.64A25.09,25.09,0,0,0,157.88,231.2Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "153.21px 246.895px"
    },
    id: "elld2pswyzlx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.53,220.16a27.72,27.72,0,0,0-5.83,8.1,30.54,30.54,0,0,0-1.58,22.53,28.14,28.14,0,0,0,4.65,8.84,48,48,0,0,1-3-9.28,39.3,39.3,0,0,1,1.5-21.41A46.56,46.56,0,0,1,126.53,220.16Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "122.103px 239.895px"
    },
    id: "elcevpdlumgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.73,221.34a15.4,15.4,0,0,0-2.84-7.57A16.44,16.44,0,0,0,145.21,207a15.55,15.55,0,0,0-7.31,3.46,20.83,20.83,0,0,1,7.5-2.06,18.1,18.1,0,0,1,15.39,6.24A20.78,20.78,0,0,1,164.73,221.34Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "151.315px 214.016px"
    },
    id: "eld1zfwkqqvki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.62,190h0a12.63,12.63,0,0,1,13.71,10.34l4.64,26,29.1,20.35-6.5,7.91-27.68-14.54a13.79,13.79,0,0,1-6.81-8.28l-8.92-30.09Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "230.115px 222.268px"
    },
    id: "el1xrqzrbz4c3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,217.94a13.49,13.49,0,0,0,5.87-6.17l-2.61-11.92A12.63,12.63,0,0,0,208.06,190l-.44.05-2.46,11.71L209,219A13.57,13.57,0,0,0,218.42,217.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "214.725px 204.669px"
    },
    id: "elxtepuhwzcsq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,217.94A13.57,13.57,0,0,1,209,219l1,4.25c3.61.81,12.86.54,15.27-7.1l-1-4.4A13.49,13.49,0,0,1,218.42,217.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "217.135px 217.656px"
    },
    id: "el9a6g119bmt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elidr3jgzff2s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.42,217.94a13.49,13.49,0,0,0,5.87-6.17l-2.61-11.92A12.63,12.63,0,0,0,208.06,190l-.44.05-2.46,11.71L209,219A13.57,13.57,0,0,0,218.42,217.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "214.725px 204.669px"
    },
    className: "animable",
    id: "elyrikfm4hsvl"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3kmqleqzsu5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.42,217.94A13.57,13.57,0,0,1,209,219l1,4.25c3.61.81,12.86.54,15.27-7.1l-1-4.4A13.49,13.49,0,0,1,218.42,217.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "217.135px 217.656px"
    },
    className: "animable",
    id: "elk1kxgxpj0fd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.06,201.19s-1.16-8.85-6.44-11.16c0,0-12.64,3.79-23.12,7.77A121.51,121.51,0,0,0,172.34,203c-2.38,2.06-9.21,8.19-12.42,9.84a15.25,15.25,0,0,1-5,1.5h0a17.46,17.46,0,0,0-6.22,2.27c-9.62,5.56-17.39,19-17.36,30.07,0,7.25,3.4,11.64,8.43,12.25v0H140a11.29,11.29,0,0,0,2.39,0c8.75-.08,22.78-.15,28.29-1.73C196.42,249.64,216.66,231,214.06,201.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "172.813px 224.512px"
    },
    id: "el7zbzj34xxkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.53,197.56l3.77-6.84,15.17,10.22-6,8.06a10.1,10.1,0,0,1-8.14.33,10.36,10.36,0,0,1-5.5-6.16A7.23,7.23,0,0,1,189.53,197.56Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "198.512px 200.375px"
    },
    id: "el7v5yj0xp48n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elopb8ghqc5j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.72,191.67c0,8.24,6.55,12.1,10.55,13.56l3.2-4.29Z",
    style: {
      opacity: 0.2,
      transformOrigin: "201.595px 198.45px"
    },
    className: "animable",
    id: "elzfgdo52sf4i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.87,183.45c-.56-3.29-1.13-6.67-.49-9.95s2.76-6.48,6-7.44a11.22,11.22,0,0,1,6.77-5.93,30.87,30.87,0,0,1,8.89-1.08,43.08,43.08,0,0,1,9.9.55,14.65,14.65,0,0,1,8.48,4.81,14.12,14.12,0,0,1,2.46,10.86,31.75,31.75,0,0,1-4.11,10.63c-6.36.45-12.84,1.18-19.2,1.63a51.25,51.25,0,0,1-9.75.09A18.13,18.13,0,0,1,187.87,183.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.606px 173.391px"
    },
    id: "el7ii6qnl32f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.81,168.2a54.37,54.37,0,0,1-3.12,29.05c-.85,2.13-2,4.34-3.95,5.47s-4.67.95-7,.59a36.12,36.12,0,0,1-11.13-3.13,15.18,15.18,0,0,1-7.7-8.3,6.69,6.69,0,0,1-6.75-2.65,12.62,12.62,0,0,1-2.19-7.36c0-1.67.31-3.64,1.81-4.37s3.06.08,4.27,1.06a12.69,12.69,0,0,1,4.16,6.24c1.1-4.07,2.81-8,3.91-12,.44-1.6,1-3.34,2.37-4.23,1.7-1.09,3.92-.47,5.89,0A38.68,38.68,0,0,0,226.81,168.2Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "206.258px 185.774px"
    },
    id: "elg4jssd7va9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.97 180.53 219.72 188.52 214.06 189.59 214.97 180.53",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "216.89px 185.06px"
    },
    id: "elc8ajegtvefv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,192.34l4.3,2.09a2.8,2.8,0,0,1-3.26.93A2.54,2.54,0,0,1,208.6,192.34Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "210.674px 193.946px"
    },
    id: "ele0gsg5z7mlt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln12je62mwbe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.6,192.34l4.3,2.09a2.8,2.8,0,0,1-3.26.93A2.54,2.54,0,0,1,208.6,192.34Z",
    style: {
      opacity: 0.3,
      transformOrigin: "210.674px 193.946px"
    },
    className: "animable",
    id: "elvqss6fn31o"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,195.5a2.58,2.58,0,0,1-1.49-.14,2.28,2.28,0,0,1-1.15-2.27,2.76,2.76,0,0,1,1.7.59A2.73,2.73,0,0,1,211.13,195.5Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "209.801px 194.321px"
    },
    id: "elt1x3gmckrqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.77,180.85a1.63,1.63,0,1,0,1.78-1.46A1.63,1.63,0,0,0,206.77,180.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.392px 181.012px"
    },
    id: "el8yyyf1h2gz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.41,181.69a1.62,1.62,0,1,0,1.78-1.45A1.62,1.62,0,0,0,220.41,181.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.022px 181.851px"
    },
    id: "elxuffhhd7btn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.63,175.41l3.34,2.84a2.32,2.32,0,0,0-.45-2.61A2.75,2.75,0,0,0,222.63,175.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "224.409px 176.677px"
    },
    id: "elidfkhu0qo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.33,175.19l-3.83,2.12a2.32,2.32,0,0,1,.95-2.47A2.76,2.76,0,0,1,209.33,175.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.382px 175.948px"
    },
    id: "elos7dpo8qpx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,171.49a132.86,132.86,0,0,1-42,0c.65-17,8.3-22.57,21.5-22.57S230,156,229.85,171.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "208.851px 161.04px"
    },
    id: "el84pw31vsga5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,171.49c0-6.51-1.26-11.51-3.73-15.14l-5.53-1.55a18.24,18.24,0,0,0-8-.42l-5.27.88a8.39,8.39,0,0,0-7,7.31l-1.21,10.26h0A133.56,133.56,0,0,0,229.85,171.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "214.48px 163.648px"
    },
    id: "el2krqq6csqbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk1yb10fz6f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.85,171.49c0-6.51-1.26-11.51-3.73-15.14l-5.53-1.55a18.24,18.24,0,0,0-8-.42l-5.27.88a8.39,8.39,0,0,0-7,7.31l-1.21,10.26h0A133.56,133.56,0,0,0,229.85,171.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.29,
      transformOrigin: "214.48px 163.648px"
    },
    className: "animable",
    id: "elibki134adbf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,157.18h-2.44c-.79,0-1.57,0-2.35.09a32.44,32.44,0,0,0-19.28,8.18l-8.22,7.38a133.56,133.56,0,0,0,30.64-1.34L235.2,165A4.8,4.8,0,0,0,231.5,157.18Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "217.74px 165.175px"
    },
    id: "elhhb21urw0tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5rad635ic3m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.5,157.18h-2.44c-.79,0-1.57,0-2.35.09a32.44,32.44,0,0,0-19.28,8.18l-8.22,7.38a133.56,133.56,0,0,0,30.64-1.34L235.2,165A4.8,4.8,0,0,0,231.5,157.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "217.74px 165.175px"
    },
    className: "animable",
    id: "eljnp8nc5ah1b"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "273.77 248.06 236.49 269.72 198.97 248.06 236.24 226.39 273.77 248.06",
    style: {
      fill: "#FF725E",
      transformOrigin: "236.37px 248.055px"
    },
    id: "eldls1yqk3yoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4metbvv160e"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "236.37px 248.055px"
    },
    className: "animable",
    id: "el72dbv7iq3p6"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.77 248.06 236.49 269.72 198.97 248.06 236.24 226.39 273.77 248.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "236.37px 248.055px"
    },
    id: "eltc3zgki2s5",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "273.77 248.06 273.66 285.98 236.38 307.64 236.49 269.72 273.77 248.06",
    style: {
      fill: "#FF725E",
      transformOrigin: "255.075px 277.85px"
    },
    id: "el52txeyprrte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7jm9s7k3vtr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "255.075px 277.85px"
    },
    className: "animable",
    id: "elkj1fb15qj5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.77 248.06 273.66 285.98 236.38 307.64 236.49 269.72 273.77 248.06",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "255.075px 277.85px"
    },
    id: "el9m83r5dzmd",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "236.49 269.72 236.38 307.64 198.86 285.98 198.97 248.06 236.49 269.72",
    style: {
      fill: "#FF725E",
      transformOrigin: "217.675px 277.85px"
    },
    id: "elar0fjytkeqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.98 245.28 255.6 237.57 249.16 233.85 236.49 241.41 242.98 245.28",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.045px 239.565px"
    },
    id: "eltl7tturb64e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.98 245.28 236.49 241.41 223.62 233.73 217.2 237.46 229.99 245.28 236.49 249.25 253.65 259.75 260.53 255.75 242.98 245.28",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "238.865px 246.74px"
    },
    id: "eloqv01anh8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.99 245.28 212.37 255.79 219.27 259.78 236.49 249.25 229.99 245.28",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.43px 252.53px"
    },
    id: "el8mb78op00gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.53 255.75 253.65 259.75 253.71 259.78 253.81 297.51 260.77 293.47 260.67 255.82 260.53 255.75",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "257.21px 276.63px"
    },
    id: "elrfjcrx5idsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.27 259.78 212.37 255.79 212.31 255.82 212.2 293.69 219.16 297.7 219.27 259.78 219.27 259.78",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "215.735px 276.745px"
    },
    id: "ellziige7pzoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7quwhvu806l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "219.27 259.78 212.37 255.79 212.31 255.82 212.2 293.69 219.16 297.7 219.27 259.78 219.27 259.78",
    style: {
      opacity: 0.2,
      transformOrigin: "215.735px 276.745px"
    },
    className: "animable",
    id: "elk0q7tyojz7"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "236.47 256.74 228.67 261.51 236.47 266.02 244.25 261.5 236.47 256.74",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "236.46px 261.38px"
    },
    id: "elg925d8nxzrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,255.43s2.91-42.35,3.52-45c2.33-10.07,16.93-9.35,18.32.89.57,4.18-6.1,44.77-6.1,44.77l24.16,25.56,4.89,4.49,4.36-.88,9.94.94a1.22,1.22,0,0,1,1.08,1h0a1.23,1.23,0,0,1-.9,1.44l-6.57,1.6,4.74,3.24a5.73,5.73,0,0,0,2.21.91l7.43,1.41a1.36,1.36,0,0,1,1.11,1.43h0a1.37,1.37,0,0,1-.88,1.2l-4,1.49a19.23,19.23,0,0,1-16-1.14L201.38,294a21.27,21.27,0,0,1-3.55-2.4L167,266.1A12.07,12.07,0,0,1,162.67,255.43Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "196.729px 252.197px"
    },
    id: "ele4z3lwb0fqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,239.2l3.09-23a12,12,0,1,0-23.87-2.92l-2.58,23.47a28.76,28.76,0,0,0,23.36,2.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "174.03px 221.656px"
    },
    id: "elrv8w1d8anun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvy00u8e9b8k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.12,239.2l3.09-23a12,12,0,1,0-23.87-2.92l-2.58,23.47a28.76,28.76,0,0,0,23.36,2.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "174.03px 221.656px"
    },
    className: "animable",
    id: "el464ig5ic1n2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.71,240.43a29.42,29.42,0,0,1-11-3.65l-.59,5.41c10.39,8,23.13,3.06,23.13,3.06l.82-6.05A29.33,29.33,0,0,1,171.71,240.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "172.095px 241.769px"
    },
    id: "elikqwni8cau9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9yjyja7rcps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.71,240.43a29.42,29.42,0,0,1-11-3.65l-.59,5.41c10.39,8,23.13,3.06,23.13,3.06l.82-6.05A29.33,29.33,0,0,1,171.71,240.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "172.095px 241.769px"
    },
    className: "animable",
    id: "elpkw9qabr4tq"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "256.195px 325.087px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.94,317.77l16.22.48,16.22-.48c.69,11-1.44,22.12-4.39,27.57h0a7.39,7.39,0,0,1-3.21,3.26c-4.79,2.77-12.52,2.77-17.28,0a7.21,7.21,0,0,1-3.2-3.35C443.36,339.77,441.25,328.67,441.94,317.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "458.16px 334.224px"
    },
    id: "eln9zdl0mjd1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.73,311.13c-6.35,3.67-6.39,9.62-.08,13.29s16.58,3.66,22.94,0,6.39-9.62.07-13.29S453.08,307.46,446.73,311.13Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "458.161px 317.773px"
    },
    id: "eljyjleif9hc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.24,312.59c-5,2.86-5,7.5-.06,10.37s12.94,2.86,17.9,0,5-7.51.05-10.37S454.2,309.73,449.24,312.59Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "458.152px 317.777px"
    },
    id: "ele2db18sz3or",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu0nw30zp3h"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "458.152px 317.777px"
    },
    className: "animable",
    id: "elhp5obgjao87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.24,312.59c-5,2.86-5,7.5-.06,10.37s12.94,2.86,17.9,0,5-7.51.05-10.37S454.2,309.73,449.24,312.59Z",
    id: "elhagctgcqmv",
    className: "animable",
    style: {
      transformOrigin: "458.152px 317.777px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M466.43,284.59c2.64-3.28,5.7-6.22,8.12-9.66,1.65-2.35,3-5.23,2.33-8a7.15,7.15,0,0,0-5.67-5,10.87,10.87,0,0,0-7.62,1.7,23.25,23.25,0,0,0-5.76,5.48A57.23,57.23,0,0,0,445.77,310a8.61,8.61,0,0,0,1.51,4.7,4.71,4.71,0,0,0,4.85,1.48c4.42-1.31,3.83-7.28,4.55-10.79a49.08,49.08,0,0,1,5.08-13.77A47.54,47.54,0,0,1,466.43,284.59Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "461.284px 289.082px"
    },
    id: "el9cd6gmglmvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluu104xugva"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.43,284.59c2.64-3.28,5.7-6.22,8.12-9.66,1.65-2.35,3-5.23,2.33-8a7.15,7.15,0,0,0-5.67-5,10.87,10.87,0,0,0-7.62,1.7,23.25,23.25,0,0,0-5.76,5.48A57.23,57.23,0,0,0,445.77,310a8.61,8.61,0,0,0,1.51,4.7,4.71,4.71,0,0,0,4.85,1.48c4.42-1.31,3.83-7.28,4.55-10.79a49.08,49.08,0,0,1,5.08-13.77A47.54,47.54,0,0,1,466.43,284.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "461.284px 289.082px"
    },
    className: "animable",
    id: "eluya2sgayvin"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M451.85,311.7a.39.39,0,0,0,.31-.37c.31-7.09,2.62-31.29,19.3-45a.37.37,0,0,0,.05-.54.38.38,0,0,0-.54-.06c-16.93,13.94-19.27,38.43-19.58,45.6a.39.39,0,0,0,.37.4Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "461.497px 288.687px"
    },
    id: "elvh85q3jplo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.42,312.46a11.8,11.8,0,0,0,5.41,7.51,15.17,15.17,0,0,0,8.2,1.38,36.27,36.27,0,0,0,8.32-2c1.34-.45,2.82-1.05,3-2.71a3,3,0,0,0-.95-2.33,9.06,9.06,0,0,0-.86-.75.85.85,0,0,1,.45-1.53,20.74,20.74,0,0,0,2.37-.3,10.35,10.35,0,0,0,5-2.25,8.26,8.26,0,0,0,2.3-3.4c.4-1.12.52-2.52-.33-3.35a3.57,3.57,0,0,0-1.84-.8c-.59-.13-1.19-.24-1.78-.33a.79.79,0,0,1-.19-1.51l2.52-1.05a4.68,4.68,0,0,0,1.91-1.19,4.16,4.16,0,0,0,.48-3.46c-.31-1.58-.85-3.1-1.22-4.66A10,10,0,0,1,482,285a40,40,0,0,0-14.09.94,10.24,10.24,0,0,0-3.85,1.68c-1.57,1.26-2,3.14-1.81,5.19a.36.36,0,0,1-.68.19L460,290a1.91,1.91,0,0,0-2.5-.8,11.62,11.62,0,0,0-3.68,2.9,6.37,6.37,0,0,0-1.57,4.7,41.4,41.4,0,0,0,1.17,6.91.63.63,0,0,1-1,.67l-.07,0a2.15,2.15,0,0,0-1.52-.44c-1.42.17-1.78,1.61-1.88,2.84A23.82,23.82,0,0,0,449.42,312.46Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "466.272px 303.099px"
    },
    id: "el4i9qto96vn5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0umqkj3nhbj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.42,312.46a11.8,11.8,0,0,0,5.41,7.51,15.17,15.17,0,0,0,8.2,1.38,36.27,36.27,0,0,0,8.32-2c1.34-.45,2.82-1.05,3-2.71a3,3,0,0,0-.95-2.33,9.06,9.06,0,0,0-.86-.75.85.85,0,0,1,.45-1.53,20.74,20.74,0,0,0,2.37-.3,10.35,10.35,0,0,0,5-2.25,8.26,8.26,0,0,0,2.3-3.4c.4-1.12.52-2.52-.33-3.35a3.57,3.57,0,0,0-1.84-.8c-.59-.13-1.19-.24-1.78-.33a.79.79,0,0,1-.19-1.51l2.52-1.05a4.68,4.68,0,0,0,1.91-1.19,4.16,4.16,0,0,0,.48-3.46c-.31-1.58-.85-3.1-1.22-4.66A10,10,0,0,1,482,285a40,40,0,0,0-14.09.94,10.24,10.24,0,0,0-3.85,1.68c-1.57,1.26-2,3.14-1.81,5.19a.36.36,0,0,1-.68.19L460,290a1.91,1.91,0,0,0-2.5-.8,11.62,11.62,0,0,0-3.68,2.9,6.37,6.37,0,0,0-1.57,4.7,41.4,41.4,0,0,0,1.17,6.91.63.63,0,0,1-1,.67l-.07,0a2.15,2.15,0,0,0-1.52-.44c-1.42.17-1.78,1.61-1.88,2.84A23.82,23.82,0,0,0,449.42,312.46Z",
    style: {
      opacity: 0.2,
      transformOrigin: "466.272px 303.099px"
    },
    className: "animable",
    id: "el9678n1kh1x"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9nakixnkaap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.42,312.46a11.8,11.8,0,0,0,5.41,7.51,15.17,15.17,0,0,0,8.2,1.38,36.27,36.27,0,0,0,8.32-2c1.34-.45,2.82-1.05,3-2.71a3,3,0,0,0-.95-2.33,9.06,9.06,0,0,0-.86-.75.85.85,0,0,1,.45-1.53,20.74,20.74,0,0,0,2.37-.3,10.35,10.35,0,0,0,5-2.25,8.26,8.26,0,0,0,2.3-3.4c.4-1.12.52-2.52-.33-3.35a3.57,3.57,0,0,0-1.84-.8c-.59-.13-1.19-.24-1.78-.33a.79.79,0,0,1-.19-1.51l2.52-1.05a4.68,4.68,0,0,0,1.91-1.19,4.16,4.16,0,0,0,.48-3.46c-.31-1.58-.85-3.1-1.22-4.66A10,10,0,0,1,482,285a40,40,0,0,0-14.09.94,10.24,10.24,0,0,0-3.85,1.68c-1.57,1.26-2,3.14-1.81,5.19a.36.36,0,0,1-.68.19L460,290a1.91,1.91,0,0,0-2.5-.8,11.62,11.62,0,0,0-3.68,2.9,6.37,6.37,0,0,0-1.57,4.7,41.4,41.4,0,0,0,1.17,6.91.63.63,0,0,1-1,.67l-.07,0a2.15,2.15,0,0,0-1.52-.44c-1.42.17-1.78,1.61-1.88,2.84A23.82,23.82,0,0,0,449.42,312.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "466.272px 303.099px"
    },
    className: "animable",
    id: "elpul4hybspbp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.89,319.59a56.82,56.82,0,0,1,3.79-11,.41.41,0,0,1,.13-.29l.27-.57a35.58,35.58,0,0,0-3.76-12.58.4.4,0,0,1,.14-.53.39.39,0,0,1,.53.15,35.85,35.85,0,0,1,3.7,11.69c3.21-6.44,8.33-14,16.23-19.46a.39.39,0,0,1,.54.1.38.38,0,0,1-.1.53c-8.15,5.68-13.29,13.54-16.41,20.06a23.73,23.73,0,0,1,13.43-1.82.4.4,0,0,1,.31.46.38.38,0,0,1-.31.3h-.15c-.07,0-7.44-1.35-13.82,2.21a56,56,0,0,0-3.76,10.89.4.4,0,0,1-.31.3h-.15A.38.38,0,0,1,456.89,319.59Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "467.705px 303.481px"
    },
    id: "el1gnz8nohrqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.33,350.91l-18.46.54-18.45-.54c-.8,12.46,1.64,25.16,5,31.37h0A8.38,8.38,0,0,0,59.08,386c5.44,3.15,14.24,3.15,19.65,0a8.14,8.14,0,0,0,3.65-3.81C85.71,375.94,88.12,363.31,87.33,350.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.874px 369.636px"
    },
    id: "eltuvgw7sk2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.88,343.35c7.23,4.18,7.27,10.94.09,15.12s-18.87,4.17-26.1,0-7.27-10.94-.09-15.12S74.65,339.18,81.88,343.35Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "68.875px 350.91px"
    },
    id: "ello6yvu516pf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,345c5.64,3.26,5.67,8.54.07,11.8s-14.72,3.25-20.36,0-5.67-8.54-.07-11.8S73.38,341.76,79,345Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "68.855px 350.902px"
    },
    id: "eljjnqb8px2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfinvwvnvddq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "68.855px 350.902px"
    },
    className: "animable",
    id: "elvbi5jbddkih"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79,345c5.64,3.26,5.67,8.54.07,11.8s-14.72,3.25-20.36,0-5.67-8.54-.07-11.8S73.38,341.76,79,345Z",
    id: "eli6fbgznht1m",
    className: "animable",
    style: {
      transformOrigin: "68.855px 350.902px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M99.22,272.16c-41.59,13.62-42,41.44-32.59,61.25,2.36,4,9.52,6.17,15.74-18.47l-10.92,1.4,12.73-6.46L87.49,300l-10.62.79,13.48-5.67A198.61,198.61,0,0,1,99.22,272.16Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "80.4302px 304.017px"
    },
    id: "elxwazkth62l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elosse5xegpnm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.22,272.16c-41.59,13.62-42,41.44-32.59,61.25,2.36,4,9.52,6.17,15.74-18.47l-10.92,1.4,12.73-6.46L87.49,300l-10.62.79,13.48-5.67A198.61,198.61,0,0,1,99.22,272.16Z",
    style: {
      opacity: 0.2,
      transformOrigin: "80.4302px 304.017px"
    },
    className: "animable",
    id: "eln2h1vy4ptyr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvufiaq1xzu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.22,272.16c-41.59,13.62-42,41.44-32.59,61.25,2.36,4,9.52,6.17,15.74-18.47l-10.92,1.4,12.73-6.46L87.49,300l-10.62.79,13.48-5.67A198.61,198.61,0,0,1,99.22,272.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "80.4302px 304.017px"
    },
    className: "animable",
    id: "elqkwwi5n9e3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,279.12c-21.93,16.64-23.91,35.73-17.71,55.65C67.55,317.23,65.18,299.49,87.45,279.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "77.0665px 306.945px"
    },
    id: "elj60az4cvxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.78,300.42c41,5.77,46,31.62,40.52,51.63-1.53,4.13-7.84,7.33-17.73-14.59L62,337,49,333.06l-4.72-8.66,10-1-13.49-3A190.85,190.85,0,0,0,28.78,300.42Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "49.9548px 327.724px"
    },
    id: "elhf0wjyhyek9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr6h9pltnpel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.78,300.42c41,5.77,46,31.62,40.52,51.63-1.53,4.13-7.84,7.33-17.73-14.59L62,337,49,333.06l-4.72-8.66,10-1-13.49-3A190.85,190.85,0,0,0,28.78,300.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "49.9548px 327.724px"
    },
    className: "animable",
    id: "elxtuqyd06ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elep43duk3mp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.78,300.42c41,5.77,46,31.62,40.52,51.63-1.53,4.13-7.84,7.33-17.73-14.59L62,337,49,333.06l-4.72-8.66,10-1-13.49-3A190.85,190.85,0,0,0,28.78,300.42Z",
    style: {
      opacity: 0.1,
      transformOrigin: "49.9548px 327.724px"
    },
    className: "animable",
    id: "elbrpvdv5x30t"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,305c23.19,11.86,28.2,29.3,25.74,48.88C65.76,337.13,65,320.22,40.89,305Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "54.0433px 329.44px"
    },
    id: "elldxwhg2nw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.21,310.11c-37.59.61-45,23.35-42.3,42,.92,3.89,6.25,7.48,17.62-11.17l-9.33-1.62,12.09-2.07L94.52,330l-8.92-2.05,12.5-1.23A171.9,171.9,0,0,1,111.21,310.11Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "89.8097px 332.671px"
    },
    id: "elp9c1gaa1st",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.79,312.83c-22.23,8.09-28.7,23.26-28.67,41.18C73.77,339.06,76.33,323.9,99.79,312.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "85.4549px 333.42px"
    },
    id: "el0c1amje3nhsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxjbp206gokg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.21,310.11c-37.59.61-45,23.35-42.3,42,.92,3.89,6.25,7.48,17.62-11.17l-9.33-1.62,12.09-2.07L94.52,330l-8.92-2.05,12.5-1.23A171.9,171.9,0,0,1,111.21,310.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "89.8097px 332.671px"
    },
    className: "animable",
    id: "el78k4s2daa9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2",
    className: "animable",
    style: {
      transformOrigin: "360.882px 305.198px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,272.54c-9.87,6.86-21,11.6-29.23,20.79-15.39,17.16-15.75,44.78-3.66,64.41s34.58,31.42,57.48,34.12c24,2.84,49.23-3.8,68.08-19s30.84-38.85,30.83-63-12.4-48.28-32.66-61.5c-18.49-12-45.05-15.49-63.6-1.7-9.37,7-15.63,17.27-25,24.27C329.56,271.47,328.8,272,328,272.54Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "369.04px 315.122px"
    },
    id: "el2vy0j77uyvw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8xk56qczl8f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,272.54c-9.87,6.86-21,11.6-29.23,20.79-15.39,17.16-15.75,44.78-3.66,64.41s34.58,31.42,57.48,34.12c24,2.84,49.23-3.8,68.08-19s30.84-38.85,30.83-63-12.4-48.28-32.66-61.5c-18.49-12-45.05-15.49-63.6-1.7-9.37,7-15.63,17.27-25,24.27C329.56,271.47,328.8,272,328,272.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "369.04px 315.122px"
    },
    className: "animable",
    id: "ell3zmw3ksqgm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnxfe9vcrdp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328,272.54c-9.87,6.86-21,11.6-29.23,20.79-15.39,17.16-15.75,44.78-3.66,64.41s34.58,31.42,57.48,34.12c24,2.84,49.23-3.8,68.08-19s30.84-38.85,30.83-63-12.4-48.28-32.66-61.5c-18.49-12-45.05-15.49-63.6-1.7-9.37,7-15.63,17.27-25,24.27C329.56,271.47,328.8,272,328,272.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "369.04px 315.122px"
    },
    className: "animable",
    id: "eliz08zxwnksf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elz92mbr2pna"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.06,373.11c0-.17.05-.33.07-.49A26,26,0,0,1,353.18,351a82,82,0,0,0,27-10.33c5.89-3.56,11.46-7.93,18.07-9.86a29.47,29.47,0,0,1,19.48,1.13c-5.56-5.83-15.08-8.4-22.69-5.76,5.26-8.07,9.9-16.75,11.72-26.21s.52-19.85-5.18-27.61A27.78,27.78,0,0,0,358.67,270c-5.65,6.18-8.83,14.88-12.54,22.38-2.67,5.39-5.42,10.91-9.82,15-6.62,6.2-16.16,8.43-23,14.36-7.79,6.73-11.15,17.48-11.18,27.77a81.39,81.39,0,0,0,3,20.53,77.91,77.91,0,0,0,28.18,17.23A30.54,30.54,0,0,1,332.06,373.11Z",
    style: {
      opacity: 0.1,
      transformOrigin: "359.93px 324.125px"
    },
    className: "animable",
    id: "el8kwc5t06jco"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.65,306.53A70.62,70.62,0,0,0,378.42,238a51.75,51.75,0,0,0-6.81,1.14,68.83,68.83,0,0,1,65.17,67.45c.45,22.51-10.57,45.46-29.46,61.38-14.8,12.48-34.46,20.76-56.08,23.73.46.07.93.13,1.39.18,1.94.23,3.89.39,5.85.5,19.2-3.73,36.59-11.64,50-23C427.84,353.09,439.1,329.6,438.65,306.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.952px 315.19px"
    },
    id: "el2k4tq6aau96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.34,389.66l2.48,4.91c3.49-3.24,4.13-5.85,4.13-5.85-1.13-4-2.45-8.07-3.11-10.05-.33,2.76-2.21,5.13-3,7.82A13.68,13.68,0,0,0,323.34,389.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "326.645px 386.62px"
    },
    id: "eldr3ttghj9vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.46,394.69l2.36-.12-2.48-4.91C323.27,391.32,323.41,393,323.46,394.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "324.57px 392.175px"
    },
    id: "eljfcf1pn377",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26,372.88a21.7,21.7,0,0,0-2.93-3.42,11.86,11.86,0,0,1-.05,6.55c-.73,2.84-2.06,5.51-2.73,8.37-.81,3.48-.62,7.22-2.1,10.48a11.21,11.21,0,0,1-7.85,6.26,4.94,4.94,0,0,1-3.74-.45,2.65,2.65,0,0,1-1-1.39,24.64,24.64,0,0,1-2.69,4.38c-1.16,1.5-2.61,3.16-2.29,5a4,4,0,0,0,3.28,3,10.6,10.6,0,0,0,4.67-.39,29.12,29.12,0,0,0,9.35-3.81,14,14,0,0,0,5.94-8,17.87,17.87,0,0,0,.36-4.85c0-1.68-.19-3.37-.12-5a13.68,13.68,0,0,1,.49-3.17c.8-2.69,2.68-5.06,3-7.82,0-.15.05-.29.06-.44A9,9,0,0,0,325.26,372.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "313.373px 390.612px"
    },
    id: "elq7yl2t06fg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfeax4frb6hg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.26,372.88a21.7,21.7,0,0,0-2.93-3.42,11.86,11.86,0,0,1-.05,6.55c-.73,2.84-2.06,5.51-2.73,8.37-.81,3.48-.62,7.22-2.1,10.48a11.21,11.21,0,0,1-7.85,6.26,4.94,4.94,0,0,1-3.74-.45,2.65,2.65,0,0,1-1-1.39,24.64,24.64,0,0,1-2.69,4.38c-1.16,1.5-2.61,3.16-2.29,5a4,4,0,0,0,3.28,3,10.6,10.6,0,0,0,4.67-.39,29.12,29.12,0,0,0,9.35-3.81,14,14,0,0,0,5.94-8,17.87,17.87,0,0,0,.36-4.85c0-1.68-.19-3.37-.12-5a13.68,13.68,0,0,1,.49-3.17c.8-2.69,2.68-5.06,3-7.82,0-.15.05-.29.06-.44A9,9,0,0,0,325.26,372.88Z",
    style: {
      opacity: 0.1,
      transformOrigin: "313.373px 390.612px"
    },
    className: "animable",
    id: "eldxju3mpwdq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.6,401.12a11.21,11.21,0,0,0,7.85-6.26c1.48-3.26,1.29-7,2.1-10.48.67-2.86,2-5.53,2.73-8.37a11.86,11.86,0,0,0,.05-6.55c-.28-.28-.56-.56-.85-.83-4.22,2.18-9,4-12.85,6.78a91.62,91.62,0,0,1-.94,14.72,34.75,34.75,0,0,1-2.85,9.15,2.65,2.65,0,0,0,1,1.39A4.94,4.94,0,0,0,309.6,401.12Z",
    style: {
      fill: "rgb(171, 97, 96)",
      transformOrigin: "313.803px 384.967px"
    },
    id: "elhltby6xtogs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.27,388.14c-.69,4.07-3.81,12.36-3.81,12.36s14.61.59,14.94-.08l4.29-6.64Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "301.075px 394.44px"
    },
    id: "el8rc8ks77i5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,291.26,301.75,312a18.47,18.47,0,0,0-9.17,19.51l7.23,39-5.93,18.85c5.12,6.86,16.87,7.21,16.87,7.21,6.56-13.15,11.37-18.73,15.09-29.75s6.21-18.62,6.21-18.62l31-8.46a36.7,36.7,0,0,0,26.83-31.22c.53-4.68.55-7.87.55-7.87Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "341.349px 343.915px"
    },
    id: "el9agiae434a4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele749xp721qa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.5,303.53a17.62,17.62,0,0,0,4.17,11.36l-23.49,14.67a18.92,18.92,0,0,0-8.06,10.5l-9.31,30.45,8.4-33.91a15.37,15.37,0,0,1,6.84-9.38L336.53,314C334.05,307.8,336.5,303.53,336.5,303.53Z",
    style: {
      opacity: 0.2,
      transformOrigin: "320.24px 337.02px"
    },
    className: "animable",
    id: "elzgl3qyt68sk"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,419.4l.34,5.48c4.49-1.6,6.1-3.75,6.1-3.75.53-4.13.92-8.39,1.1-10.47-1.4,2.41-4.06,3.85-5.85,6A12.81,12.81,0,0,0,299.39,419.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "303.16px 417.77px"
    },
    id: "el9jfkvubbju8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.52,424.06l2.21.82-.34-5.48C298.67,420.89,298.13,422.5,297.52,424.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.625px 422.14px"
    },
    id: "els29m40m5z8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.74,404.71a22,22,0,0,0-1.34-4.29,11.9,11.9,0,0,1-2.62,6c-1.79,2.32-4.07,4.25-5.8,6.61-2.12,2.89-3.42,6.4-6.05,8.81a11.24,11.24,0,0,1-9.69,2.68,4.94,4.94,0,0,1-3.25-1.89,2.67,2.67,0,0,1-.4-1.68,25,25,0,0,1-4.19,3c-1.66.93-3.65,1.88-4.09,3.73a4,4,0,0,0,1.84,4,10.58,10.58,0,0,0,4.44,1.48,29.06,29.06,0,0,0,10.1.17,13.91,13.91,0,0,0,8.58-5,17.92,17.92,0,0,0,2.25-4.32c.61-1.56,1.15-3.17,1.87-4.66a12.81,12.81,0,0,1,1.69-2.73c1.79-2.16,4.45-3.6,5.85-6,.07-.12.16-.24.23-.38A9,9,0,0,0,307.74,404.71Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "289.1px 417.056px"
    },
    id: "el0jgxyssz90x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.24,424.53a11.24,11.24,0,0,0,9.69-2.68c2.63-2.41,3.93-5.92,6.05-8.81,1.73-2.36,4-4.29,5.8-6.61a11.9,11.9,0,0,0,2.62-6l-.45-1.1c-4.74.35-9.86.12-14.49,1.18a90.66,90.66,0,0,1-6.65,13.16,34.27,34.27,0,0,1-6.22,7.3,2.67,2.67,0,0,0,.4,1.68A4.94,4.94,0,0,0,282.24,424.53Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "292.489px 412.035px"
    },
    id: "el8if3anof0uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.24,236.19a59.31,59.31,0,0,0,1-44.4c-1.74-4.54-4.2-9-8.23-11.77-5.16-3.48-11.83-3.43-18.05-3.25-3.3.1-6.67.2-9.77,1.34a10.07,10.07,0,0,0-6.45,6.79c-4.07-.75-8.17,2.46-9.27,6.45s.34,8.33,2.87,11.61,6,5.63,9.56,7.78c-2.14,1.12-3.72,3.7-4.46,6a9.46,9.46,0,0,0,.49,7,9.37,9.37,0,0,0-8.73,6.22,11.78,11.78,0,0,0,2.11,10.6,17.14,17.14,0,0,0,9.36,5.86,32,32,0,0,0,11.18.6c3.86,3.74,10.93,3.66,15.78,1.34S375.09,241.11,377.24,236.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.904px 213.346px"
    },
    id: "eldbvp4q0x83",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,226.8h-.95c-6.35.07-14.39,4.4-18.32,15.48l-15.26,29.56,17.42,7.72,9.53-27.9Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "325.425px 253.18px"
    },
    id: "elj5ckmhcfigr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,246.42c-1.21,3.49-1.29,7.25-1.48,11s-.62,8.14-2.31,11.43a10.49,10.49,0,0,0-12.56.46,9.68,9.68,0,0,0-2.82,4l14.3,6.34,9.53-27.9,4.69-15.38A17.84,17.84,0,0,0,330.45,246.42Z",
    style: {
      fill: "rgb(171, 97, 96)",
      transformOrigin: "325.54px 258.01px"
    },
    id: "elfvd0wlq6bjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.74,274.24a10.38,10.38,0,0,0-7.88-6.37c-3.49-.57-7.44,1.26-9.7,4-1.9,2.29-1.6,5.4-.4,8.13a10.14,10.14,0,0,0,11.62,5.5C323.88,284.23,327.44,278.59,325.74,274.24Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "316.485px 276.784px"
    },
    id: "el1w5371ysz2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,226.26c-6.72,1.07-10.89,18.07-13.07,24.53-2.26,6.67.81,11.51,4.23,15.54h0a6.9,6.9,0,0,1,1.57,5.34L330,297.94c19.3,14.33,51.66,7.39,60.44,2.71a62,62,0,0,0-5.67-26.6,43.81,43.81,0,0,1-4.28-17.21l-.33-9.64,2.33-16.64-16.76-4-14.77-.66A58.78,58.78,0,0,0,344.29,226.26Z",
    style: {
      fill: "#FF725E",
      transformOrigin: "360.222px 266.204px"
    },
    id: "elejhh7q31g1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elepv1bed8kfq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.29,226.26c-6.72,1.07-10.89,18.07-13.07,24.53-2.26,6.67.81,11.51,4.23,15.54h0a6.9,6.9,0,0,1,1.57,5.34L330,297.94c19.3,14.33,51.66,7.39,60.44,2.71a62,62,0,0,0-5.67-26.6,43.81,43.81,0,0,1-4.28-17.21l-.33-9.64,2.33-16.64-16.76-4-14.77-.66A58.78,58.78,0,0,0,344.29,226.26Z",
    style: {
      opacity: 0.4,
      transformOrigin: "360.222px 266.204px"
    },
    className: "animable",
    id: "elihg8xiuqe"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      transformOrigin: "329.167px 287.652px"
    },
    id: "elfnku2omw1cp",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.14,302.16v0h0a0,0,0,0,1,0,0s0,0,0-.06a77265801265.14,77265801265.14,0,0,0,0-.12l0-.06,0-.05,0-.06h0l-11.4-21.23,0-.06,0-.06,0-.06-.05-.07,0-.07a163246272339.33,163246272339.33,0,0,1-.1-.14l-.06-.06-.05-.07,0-.05,0-.05,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.17-.15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.06,0-.05,0-.06,0-.07,0-.07-.05-.08,0,0,0L317,270.74l0,0-.08,0-.07,0-.08,0-.07,0-.07,0-.07,0-.06,0-.07,0-.08,0h-.07l-.08,0H316a.31.31,0,0,0-.2.08l-1.56,1.79h.05c-.13.1-.14.31.05.66l11.4,21.23a7.35,7.35,0,0,0,2.52,2.38l13.11,7.38c.67.38,1.08.39,1.14.11,0,0,0,.1,0,.12h0l1.57-1.79a.2.2,0,0,0,0-.08.17.17,0,0,0,0-.07Zm-29.56-29.92s0,0,.09,0h0l.05,0Zm15,8.47c.12.1.25.2.36.31h0C329.86,280.91,329.73,280.81,329.61,280.71Zm.82.8.16.17h0ZM342.57,304a1.17,1.17,0,0,0-.14-.43,1.24,1.24,0,0,1,.14.39h0S342.56,303.94,342.57,304Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "329.167px 287.652px"
    },
    id: "elwb8hb7crnkf",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkpgnvu7z7w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.14,302.16v0h0a0,0,0,0,1,0,0s0,0,0-.06a77265801265.14,77265801265.14,0,0,0,0-.12l0-.06,0-.05,0-.06h0l-11.4-21.23L331,282.3l11.41,21.23a1.24,1.24,0,0,1,.14.39h0a.26.26,0,0,1-.05.24h0l1.57-1.79a.2.2,0,0,0,0-.08.17.17,0,0,0,0-.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.15,
      transformOrigin: "337.57px 292.37px"
    },
    className: "animable",
    id: "elsnluo4rvgio"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk08l6r0ocaf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.55,280.45l0-.06,0-.06-.05-.07,0-.07a163246272339.33,163246272339.33,0,0,1-.1-.14l-.06-.06-.05-.07,0-.05,0-.05,0-.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.17-.15,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.06,0-.05,0-.06,0-.07,0-.07-.05-.08,0,0,0L317,270.74l0,0-.08,0-.07,0-.08,0-.07,0-.07,0-.07,0-.06,0-.07,0-.08,0h-.07l-.08,0H316a.31.31,0,0,0-.2.08l-1.56,1.79q.11-.12.39-.06h0a2.77,2.77,0,0,1,.72.3l13.11,7.38a5.33,5.33,0,0,1,.75.49h0a8.42,8.42,0,0,1,.72.62h0a6.32,6.32,0,0,1,.62.66h0a3.89,3.89,0,0,1,.43.62l1.57-1.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "323.395px 276.68px"
    },
    className: "animable",
    id: "elpfuwbzujohp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.92,236.12c-1.86-3.19-4.3-5.64-8-5.92,0,0-6,3.12-6,17.28l.4,35.43h0c-.87.35-1.74.72-2.6,1.08a106,106,0,0,1-22.79,6.89A22.51,22.51,0,0,0,335.55,286l1.93,3.6c-3.66,2.35-11.94-1.88-11.94-1.88-.61,5.16,2.74,10.52,7.18,13.23s46.78-1.27,55.76-7.08c5.91-3.82,4.51-40.35,4.51-40.35A30.56,30.56,0,0,0,388.92,236.12Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "359.301px 266.009px"
    },
    id: "elhrq1dnl52v7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.59,277a24.48,24.48,0,0,0-.48,4.23,15.49,15.49,0,0,0,4.08,9.06,4.6,4.6,0,0,0,1.76,1.24,2,2,0,0,0,2-.32,3.07,3.07,0,0,0,.71-2.13,11.25,11.25,0,0,0-.19-3.43,4.75,4.75,0,0,0-1.81-2.85,10.22,10.22,0,0,0-2.29-1,5.6,5.6,0,0,1-2-1.48Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "320.412px 284.334px"
    },
    id: "elwla71fv9ml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.91,219.33v13.38c-1.31,1.24-2.57,2.66-2.69,4.43a4.62,4.62,0,0,0,2.39,4.17,6.51,6.51,0,0,0,4.92.48,11.22,11.22,0,0,0,4.35-2.52,18.08,18.08,0,0,0,5.8-12.7V213Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "356.949px 227.533px"
    },
    id: "elnskpx2t9hp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.11,213c-1.4,7.36-4.27,13.74-14.2,16v-9.72Z",
    style: {
      fill: "rgb(171, 97, 96)",
      transformOrigin: "358.01px 221px"
    },
    id: "eld8pdmjqag2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.64,205.26a14.54,14.54,0,0,0,0,3.55,4.2,4.2,0,0,0,1.27,2.32,2.65,2.65,0,0,0,2.42.61,4.63,4.63,0,0,1,8.89-2.56,5.78,5.78,0,0,1-.77,4.85,11,11,0,0,1-3.73,3.38,3.91,3.91,0,0,1-4.74-1.64c-4.27,5.89-11.94,10.49-19.31,10.17A10.52,10.52,0,0,1,340,224.2c-2.86-2-3.2-5.27-3.68-8.47a45.07,45.07,0,0,1-.41-12.22c.67-5.62,2.93-11.22,7.12-15C346,200.53,357.34,204.54,361.64,205.26Z",
    style: {
      fill: "rgb(196, 130, 129)",
      transformOrigin: "355.06px 207.233px"
    },
    id: "elhqktxoqod3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.28 204.5 341.5 210.91 346.25 212.33 346.28 204.5",
    style: {
      fill: "rgb(171, 97, 96)",
      transformOrigin: "343.89px 208.415px"
    },
    id: "el6zxe9hsgo1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.67,215.18l-3.87,1.4a2.43,2.43,0,0,0,2.71,1.08A2.18,2.18,0,0,0,350.67,215.18Z",
    style: {
      fill: "rgb(171, 97, 96)",
      transformOrigin: "348.767px 216.462px"
    },
    id: "el7bh07zkmhcr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr02d1tdwtpk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.67,215.18l-3.87,1.4a2.43,2.43,0,0,0,2.71,1.08A2.18,2.18,0,0,0,350.67,215.18Z",
    style: {
      opacity: 0.3,
      transformOrigin: "348.767px 216.462px"
    },
    className: "animable",
    id: "elda92p83seyr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,217.65a2.27,2.27,0,0,0,1.29,0,2,2,0,0,0,1.18-1.83,2.23,2.23,0,0,0-2.47,1.82Z",
    style: {
      fill: "rgb(171, 97, 96)",
      transformOrigin: "349.455px 216.773px"
    },
    id: "elj267hkfjl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.26,205.51a1.4,1.4,0,1,1-1.39-1.4A1.39,1.39,0,0,1,353.26,205.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "351.86px 205.51px"
    },
    id: "elzgvmzvqkl6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.53,205a1.41,1.41,0,0,1-1.41,1.39,1.4,1.4,0,0,1,0-2.8A1.41,1.41,0,0,1,341.53,205Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.125px 204.99px"
    },
    id: "elw41d4zc3pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,199.44l-3.11,2.13a2,2,0,0,1,.62-2.19A2.36,2.36,0,0,1,340.19,199.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.581px 200.312px"
    },
    id: "elya80hd448e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.16,199.32l3.09,2.16a2,2,0,0,0-.59-2.2A2.37,2.37,0,0,0,352.16,199.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.764px 200.212px"
    },
    id: "elmxgyr7m00ib",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderlist);
export default __webpack_public_path__ + "static/media/Orderlist.ca04c5248c3fa896361e4ef630f7d8b3.svg";
export { ForwardRef as ReactComponent };